/**
 * Data Module
 * Manages wallpaper data and categories
 * Auto-generated by update_data.py
 */

import { supabase } from './supabaseClient.js';
import { authManager } from './auth.js';

const wallpaperData = {
  "aesthetic": [
    {
      "id": "a-flutter-in-the-stillness",
      "uuid": "d75ada55-42a3-5c73-9fb0-f39b49295416",
      "filename": "A Flutter in the Stillness.png",
      "title": "A Flutter in the Stillness",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "lake",
        "aesthetic",
        "petals",
        "serene",
        "anime scenery",
        "reflection",
        "cherry blossom",
        "twilight",
        "japanese",
        "purple",
        "pagoda"
      ],
      "colors": [
        "#817a9a",
        "#1c2641"
      ],
      "resolution": "4096x2292",
      "fileSize": "12.4 MB",
      "variants": {
        "original": {
          "url": "A Flutter in the Stillness.png",
          "resolution": "4096x2292",
          "size": "12.4 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "celestial-dream",
      "uuid": "cd76c473-e4af-5f14-90e9-d503e71e26c7",
      "filename": "Celestial Dream.png",
      "title": "Celestial Dream",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "aesthetic",
        "celestial",
        "dream"
      ],
      "colors": [
        "#fdcb52",
        "#b08a4d"
      ],
      "resolution": "4096x2304",
      "fileSize": "6.7 MB",
      "variants": {
        "original": {
          "url": "Celestial Dream.png",
          "resolution": "4096x2304",
          "size": "6.7 MB"
        }
      },
      "uploadDate": "2026-03-12",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "cosmic-lullaby-over-concrete-jungles",
      "uuid": "1f61216f-e2ad-5232-ae96-b3d53e4911bb",
      "filename": "Cosmic Lullaby Over Concrete Jungles.png",
      "title": "Cosmic Lullaby Over Concrete Jungles",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "anime girl",
        "rooftop",
        "aesthetic",
        "lofi",
        "city",
        "urban",
        "headphones",
        "sunset",
        "shooting star",
        "cityscape",
        "night sky",
        "stars"
      ],
      "colors": [
        "#57475d",
        "#151a37"
      ],
      "resolution": "4096x2304",
      "fileSize": "16.4 MB",
      "variants": {
        "original": {
          "url": "Cosmic Lullaby Over Concrete Jungles.png",
          "resolution": "4096x2304",
          "size": "16.4 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "lofi-study-&-chill",
      "uuid": "44d10ed8-25f0-5692-ab07-a8f9b61bf2ed",
      "filename": "Lofi Study & Chill.png",
      "title": "Lofi Study & Chill",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "anime girl",
        "aesthetic",
        "lofi",
        "pink",
        "relaxing",
        "cozy room",
        "headphones",
        "chill",
        "music",
        "study",
        "soft"
      ],
      "colors": [
        "#ebc1bd",
        "#8d647c"
      ],
      "resolution": "4096x2304",
      "fileSize": "1.5 MB",
      "variants": {
        "original": {
          "url": "Lofi Study & Chill.png",
          "resolution": "4096x2304",
          "size": "1.5 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "stardust,-shiba,-and-sentiments",
      "uuid": "70d6bbfc-1b7a-5512-bff7-614956ddd115",
      "filename": "Stardust, Shiba, and Sentiments.png",
      "title": "Stardust, Shiba, and Sentiments",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "dog",
        "aesthetic",
        "friends",
        "shiba inu",
        "twilight",
        "hill",
        "couple",
        "sunset",
        "colorful sky",
        "stargazing",
        "peaceful"
      ],
      "colors": [
        "#c592a9",
        "#554153"
      ],
      "resolution": "4096x2304",
      "fileSize": "10.5 MB",
      "variants": {
        "original": {
          "url": "Stardust, Shiba, and Sentiments.png",
          "resolution": "4096x2304",
          "size": "10.5 MB"
        }
      },
      "uploadDate": "2026-04-22",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "sunflower-reflections-in-her-glass",
      "uuid": "f2dd62be-d075-5b74-b16e-9f84979b1f97",
      "filename": "Sunflower reflections in her glass.png",
      "title": "Sunflower Reflections In Her Glass",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "aesthetic",
        "reflections",
        "her",
        "sunflower",
        "glass"
      ],
      "colors": [
        "#96897a",
        "#4a4540"
      ],
      "resolution": "2304x4096",
      "fileSize": "14.2 MB",
      "variants": {
        "original": {
          "url": "Sunflower reflections in her glass.png",
          "resolution": "2304x4096",
          "size": "14.2 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-long-walk-home",
      "uuid": "f0e99f05-29a4-5a24-a856-9317658f8e8f",
      "filename": "The Long Walk Home.png",
      "title": "The Long Walk Home",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "anime girl",
        "backpack",
        "aesthetic",
        "journey",
        "walk",
        "city",
        "road",
        "twilight",
        "sunset",
        "colorful sky",
        "cityscape"
      ],
      "colors": [
        "#7b5f74",
        "#23161f"
      ],
      "resolution": "4096x2304",
      "fileSize": "17.9 MB",
      "variants": {
        "original": {
          "url": "The Long Walk Home.png",
          "resolution": "4096x2304",
          "size": "17.9 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-messy-mind-of-a-programmer",
      "uuid": "0c22fb13-f267-51ce-b4db-04f5ee9e7e91",
      "filename": "The Messy Mind of a Programmer.png",
      "title": "The Messy Mind of a Programmer",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "moonlight",
        "aesthetic",
        "programmer",
        "bedroom",
        "cozy room",
        "night",
        "blue glow",
        "desk",
        "computer",
        "anime",
        "messy",
        "study"
      ],
      "colors": [
        "#284065",
        "#0b1424"
      ],
      "resolution": "4096x2304",
      "fileSize": "8.1 MB",
      "variants": {
        "original": {
          "url": "The Messy Mind of a Programmer.png",
          "resolution": "4096x2304",
          "size": "8.1 MB"
        }
      },
      "uploadDate": "2026-04-22",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-silent-symphony-of-the-city",
      "uuid": "50f3a4dc-5cb0-5af0-bd9f-3f863169f3b7",
      "filename": "The Silent Symphony of the City.png",
      "title": "The Silent Symphony of the City",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "rooftop",
        "aesthetic",
        "lofi",
        "anime boy",
        "city",
        "urban",
        "night",
        "headphones",
        "solitude",
        "shooting star",
        "galaxy",
        "stars"
      ],
      "colors": [
        "#3a3c64",
        "#0f1730"
      ],
      "resolution": "4096x2304",
      "fileSize": "14.8 MB",
      "variants": {
        "original": {
          "url": "The Silent Symphony of the City.png",
          "resolution": "4096x2304",
          "size": "14.8 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "bare-shoulder-reverie",
      "uuid": "876c558e-d3d3-40ee-927d-f1e27c0d5a5a",
      "filename": "Bare Shoulder Reverie.png",
      "title": "Bare Shoulder Reverie",
      "category": "Aesthetic",
      "subcategory": null,
      "tags": [
        "portrait",
        "redhead",
        "bare back",
        "studio",
        "moody",
        "elegant",
        "aesthetic"
      ],
      "colors": [
        "#0b0a0b",
        "#543b29"
      ],
      "resolution": "6688x3764",
      "fileSize": "0.7 MB",
      "variants": {
        "original": {
          "url": "Bare Shoulder Reverie.png",
          "resolution": "6688x3764",
          "size": "0.7 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    }
  ],
  "anime": [
    {
      "id": "curious-kittens-on-a-mossy-roof",
      "uuid": "251daf97-e365-553e-af19-f6747bfbcff0",
      "filename": "Curious kittens on a mossy roof.png",
      "title": "Curious Kittens on a Mossy Roof",
      "category": "Anime",
      "subcategory": null,
      "tags": [
        "black cat",
        "sunlight",
        "animals",
        "kittens",
        "cats",
        "cute",
        "white cat",
        "anime",
        "mossy roof",
        "adorable"
      ],
      "colors": [
        "#bfc574",
        "#41442a"
      ],
      "resolution": "4096x2304",
      "fileSize": "15.2 MB",
      "variants": {
        "original": {
          "url": "Curious kittens on a mossy roof.png",
          "resolution": "4096x2304",
          "size": "15.2 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "mist-y-morning-in-the-snow",
      "uuid": "d0abde2a-25f9-577c-bd41-64a2186373b5",
      "filename": "Mist-y Morning in the Snow.png",
      "title": "Mist-y Morning in the Snow",
      "category": "Anime",
      "subcategory": null,
      "tags": [
        "anime girl",
        "anime",
        "scarf",
        "cold",
        "snowflakes",
        "snow",
        "cozy",
        "cute",
        "cheerful",
        "winter"
      ],
      "colors": [
        "#eef3f8",
        "#b3c4d3"
      ],
      "resolution": "4096x2304",
      "fileSize": "7.9 MB",
      "variants": {
        "original": {
          "url": "Mist-y Morning in the Snow.png",
          "resolution": "4096x2304",
          "size": "7.9 MB"
        }
      },
      "uploadDate": "2026-04-22",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "attack-on-titan-kawaii",
      "uuid": "5cac0ec1-6351-5775-8c72-e1aa22fb4688",
      "filename": "Attack-on-titan/Attack on Titan Kawaii.png",
      "title": "Attack On Titan Kawaii",
      "category": "Anime",
      "subcategory": "Attack-on-titan",
      "tags": [
        "anime",
        "titan",
        "attack",
        "kawaii",
        "Attack-on-titan"
      ],
      "colors": [
        "#d1d8ba",
        "#9a927a"
      ],
      "resolution": "4089x2300",
      "fileSize": "7.9 MB",
      "variants": {
        "original": {
          "url": "Attack-on-titan/Attack on Titan Kawaii.png",
          "resolution": "4089x2300",
          "size": "7.9 MB"
        }
      },
      "uploadDate": "2026-03-12",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "chibi-mikasas-resolve",
      "uuid": "79adf934-96a4-5269-bc94-5e3f361c816d",
      "filename": "Attack-on-titan/Chibi Mikasas Resolve.png",
      "title": "Chibi Mikasa's Resolve",
      "category": "Anime",
      "subcategory": "Attack-on-titan",
      "tags": [
        "survey corps",
        "scarf",
        "mikasa ackermann",
        "uniform",
        "attack on titan",
        "aot",
        "chibi",
        "cute",
        "anime",
        "scouts",
        "Attack-on-titan"
      ],
      "colors": [
        "#e2654b",
        "#642d24"
      ],
      "resolution": "2700x4800",
      "fileSize": "12.5 MB",
      "variants": {
        "original": {
          "url": "Attack-on-titan/Chibi Mikasas Resolve.png",
          "resolution": "2700x4800",
          "size": "12.5 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "hatsune-miku-in-tokyo-vibes",
      "uuid": "b1424408-5bc3-5431-be41-e0c98772fed5",
      "filename": "Hatsune Miku/Hatsune Miku in Tokyo vibes.png",
      "title": "Hatsune Miku in Tokyo Vibes",
      "category": "Anime",
      "subcategory": "Hatsune Miku",
      "tags": [
        "tokyo",
        "vocaloid",
        "city",
        "japan",
        "teal hair",
        "hatsune miku",
        "music",
        "social media",
        "singer",
        "anime",
        "Hatsune Miku"
      ],
      "colors": [
        "#c3d1dd",
        "#59758e"
      ],
      "resolution": "4096x2728",
      "fileSize": "16.6 MB",
      "variants": {
        "original": {
          "url": "Hatsune Miku/Hatsune Miku in Tokyo vibes.png",
          "resolution": "4096x2728",
          "size": "16.6 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "mikus-refreshment",
      "uuid": "d1c414b5-db2a-59a8-bba4-30670088db62",
      "filename": "Hatsune Miku/Mikus Refreshment.png",
      "title": "Mikus Refreshment",
      "category": "Anime",
      "subcategory": "Hatsune Miku",
      "tags": [
        "anime",
        "mikus",
        "refreshment",
        "Hatsune Miku"
      ],
      "colors": [
        "#edece6",
        "#a3b4af"
      ],
      "resolution": "2304x4096",
      "fileSize": "7.9 MB",
      "variants": {
        "original": {
          "url": "Hatsune Miku/Mikus Refreshment.png",
          "resolution": "2304x4096",
          "size": "7.9 MB"
        }
      },
      "uploadDate": "2025-12-20",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "high-school-dxd",
      "uuid": "47cee342-6e4a-5637-a7f5-f63f94657eb9",
      "filename": "High-School-DxD/High School DxD.png",
      "title": "High School Dxd",
      "category": "Anime",
      "subcategory": "High-School-DxD",
      "tags": [
        "anime",
        "school",
        "high",
        "dxd",
        "High-School-DxD"
      ],
      "colors": [
        "#f6dedb",
        "#874845"
      ],
      "resolution": "2304x4096",
      "fileSize": "10.3 MB",
      "variants": {
        "original": {
          "url": "High-School-DxD/High School DxD.png",
          "resolution": "2304x4096",
          "size": "10.3 MB"
        }
      },
      "uploadDate": "2026-03-12",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "hori-and-miya-the-urban-drip",
      "uuid": "13c39eb5-1f9e-5764-9113-994151a6a573",
      "filename": "Horimiya/Hori and Miya The Urban Drip.png",
      "title": "Hori and Miya: The Urban Drip",
      "category": "Anime",
      "subcategory": "Horimiya",
      "tags": [
        "anime",
        "izumi miyamura",
        "fashion",
        "urban",
        "modern",
        "kyoko hori",
        "couple",
        "horimiya",
        "romance",
        "Horimiya"
      ],
      "colors": [
        "#aa927f",
        "#342a2f"
      ],
      "resolution": "2304x4096",
      "fileSize": "17.7 MB",
      "variants": {
        "original": {
          "url": "Horimiya/Hori and Miya The Urban Drip.png",
          "resolution": "2304x4096",
          "size": "17.7 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "jujutsu-kaisen",
      "uuid": "2015aa38-b7f6-5f20-8935-05c8d4086ad8",
      "filename": "Jujutsu-Kaisen/Jujutsu Kaisen.png",
      "title": "Jujutsu Kaisen",
      "category": "Anime",
      "subcategory": "Jujutsu-Kaisen",
      "tags": [
        "anime",
        "jujutsu",
        "kaisen",
        "Jujutsu-Kaisen"
      ],
      "colors": [
        "#f6ca76",
        "#5a4848"
      ],
      "resolution": "1728x3072",
      "fileSize": "5.5 MB",
      "variants": {
        "original": {
          "url": "Jujutsu-Kaisen/Jujutsu Kaisen.png",
          "resolution": "1728x3072",
          "size": "5.5 MB"
        }
      },
      "uploadDate": "2026-03-12",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "aquas-social-media-moment",
      "uuid": "3caf5d5b-451b-53e2-a9af-971bc105907d",
      "filename": "KonoSuba/Aqua's social media moment.png",
      "title": "Aqua's Social Media Moment",
      "category": "Anime",
      "subcategory": "KonoSuba",
      "tags": [
        "blue hair",
        "konosuba",
        "aqua",
        "fantasy town",
        "instagram",
        "cute",
        "social media",
        "anime",
        "goddess",
        "KonoSuba"
      ],
      "colors": [
        "#c9dae5",
        "#707f97"
      ],
      "resolution": "4096x2728",
      "fileSize": "2.7 MB",
      "variants": {
        "original": {
          "url": "KonoSuba/Aqua's social media moment.png",
          "resolution": "4096x2728",
          "size": "2.7 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "2b--mourning-the-machine-age",
      "uuid": "17788b55-d531-5439-9c6a-56f0e7092608",
      "filename": "NieR-Automata/2B- Mourning the Machine Age.png",
      "title": "2B: Mourning the Machine Age",
      "category": "Anime",
      "subcategory": "NieR-Automata",
      "tags": [
        "ruins",
        "anime",
        "2b",
        "robot",
        "nier automata",
        "monochrome",
        "android",
        "dark",
        "sci-fi",
        "sword",
        "post-apocalyptic",
        "NieR-Automata"
      ],
      "colors": [
        "#c1c1c1",
        "#5d5d5d"
      ],
      "resolution": "4096x2304",
      "fileSize": "5.4 MB",
      "variants": {
        "original": {
          "url": "NieR-Automata/2B- Mourning the Machine Age.png",
          "resolution": "4096x2304",
          "size": "5.4 MB"
        }
      },
      "uploadDate": "2026-04-22",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "climate-tactician-namis-golden-gaze",
      "uuid": "3df58aa3-5f7f-5cb1-9591-2f4379d94d2f",
      "filename": "One-Piece/Climate Tactician Namis Golden Gaze.png",
      "title": "Climate Tactician: Nami's Golden Gaze",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "climate tact",
        "nami",
        "gaze",
        "anime",
        "one piece",
        "golden",
        "One-Piece"
      ],
      "colors": [
        "#fed0d0",
        "#bf8f87"
      ],
      "resolution": "2340x4096",
      "fileSize": "6.1 MB",
      "variants": {
        "original": {
          "url": "One-Piece/Climate Tactician Namis Golden Gaze.png",
          "resolution": "2340x4096",
          "size": "6.1 MB"
        }
      },
      "uploadDate": "2026-02-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "luffy-gear-5",
      "uuid": "2a27a6a9-45e9-5902-9f3c-4a27a0936b15",
      "filename": "One-Piece/Luffy Gear 5.png",
      "title": "Luffy Gear 5",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "anime",
        "luffy",
        "gear",
        "One-Piece"
      ],
      "colors": [
        "#ab9b94",
        "#463e3c"
      ],
      "resolution": "4096x2728",
      "fileSize": "23.8 MB",
      "variants": {
        "original": {
          "url": "One-Piece/Luffy Gear 5.png",
          "resolution": "4096x2728",
          "size": "23.8 MB"
        }
      },
      "uploadDate": "2026-03-12",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "luffys-graffiti-playground",
      "uuid": "19523693-1afe-59f9-97aa-ab32be217261",
      "filename": "One-Piece/Luffys Graffiti Playground.png",
      "title": "Luffy's Graffiti Playground",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "street art",
        "urban",
        "modern",
        "graffiti",
        "casual",
        "anime",
        "one piece",
        "monkey d. luffy",
        "One-Piece"
      ],
      "colors": [
        "#b29b8c",
        "#403840"
      ],
      "resolution": "2304x4096",
      "fileSize": "13.3 MB",
      "variants": {
        "original": {
          "url": "One-Piece/Luffys Graffiti Playground.png",
          "resolution": "2304x4096",
          "size": "13.3 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "namis-high-tide-happiness",
      "uuid": "f4ef5a74-8278-5a73-8b85-bf8184e774f1",
      "filename": "One-Piece/Nami's High Tide Happiness.png",
      "title": "Nami's High Tide Happiness",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "water",
        "anime",
        "tropical",
        "nami",
        "sunshine",
        "beach",
        "ocean",
        "summer",
        "one piece",
        "happy",
        "One-Piece"
      ],
      "colors": [
        "#90b4c5",
        "#4e667a"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.4 MB",
      "variants": {
        "original": {
          "url": "One-Piece/Nami's High Tide Happiness.png",
          "resolution": "4096x2304",
          "size": "2.4 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "street-style-luffys-urban-pirate-vibes",
      "uuid": "6dda9041-4af6-56d7-b833-ac01cf025496",
      "filename": "One-Piece/Street Style Luffys Urban Pirate Vibes.png",
      "title": "Street Style: Luffy's Urban Pirate Vibes",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "urban",
        "modern",
        "street style",
        "pirate",
        "anime",
        "one piece",
        "monkey d. luffy",
        "One-Piece"
      ],
      "colors": [
        "#bdcec3",
        "#664f45"
      ],
      "resolution": "2304x4096",
      "fileSize": "8.9 MB",
      "variants": {
        "original": {
          "url": "One-Piece/Street Style Luffys Urban Pirate Vibes.png",
          "resolution": "2304x4096",
          "size": "8.9 MB"
        }
      },
      "uploadDate": "2026-01-28",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-cat-burglars-shore-leave",
      "uuid": "cc757e2a-9e44-587d-800c-3937c02284c0",
      "filename": "One-Piece/The Cat Burglar's Shore Leave.png",
      "title": "The Cat Burglar's Shore Leave",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "anime",
        "straw hat",
        "tropical",
        "nami",
        "wink",
        "beach",
        "ocean",
        "summer",
        "one piece",
        "vacation",
        "happy",
        "One-Piece"
      ],
      "colors": [
        "#8aaeb8",
        "#935550"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.5 MB",
      "variants": {
        "original": {
          "url": "One-Piece/The Cat Burglar's Shore Leave.png",
          "resolution": "4096x2304",
          "size": "2.5 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-fire-fists-horizon",
      "uuid": "56b65fac-ea4b-5674-ba52-0f0067d0e230",
      "filename": "One-Piece/The Fire Fists Horizon.png",
      "title": "The Fire Fist's Horizon",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "flame",
        "fire fist",
        "portgas d. ace",
        "pirate",
        "sunset",
        "anime",
        "one piece",
        "brother",
        "One-Piece"
      ],
      "colors": [
        "#cba497",
        "#692e28"
      ],
      "resolution": "2304x4096",
      "fileSize": "11.1 MB",
      "variants": {
        "original": {
          "url": "One-Piece/The Fire Fists Horizon.png",
          "resolution": "2304x4096",
          "size": "11.1 MB"
        }
      },
      "uploadDate": "2025-12-20",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-will-of-d-and-the-azure-horizon",
      "uuid": "7d9b1d4b-164d-5069-b76f-aadb29b34ea5",
      "filename": "One-Piece/The Will of D and the Azure Horizon.png",
      "title": "The Will of D and the Azure Horizon",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "sea",
        "straw hat",
        "adventure",
        "thousand sunny",
        "sunshine",
        "pirate",
        "ocean",
        "anime",
        "one piece",
        "monkey d. luffy",
        "One-Piece"
      ],
      "colors": [
        "#9fbbcc",
        "#6b4f5e"
      ],
      "resolution": "4096x2304",
      "fileSize": "15.2 MB",
      "variants": {
        "original": {
          "url": "One-Piece/The Will of D and the Azure Horizon.png",
          "resolution": "4096x2304",
          "size": "15.2 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "emerald-memories---route-110",
      "uuid": "499efc7b-b3a1-5871-bad7-321d96f77a1f",
      "filename": "Pokemon/Emerald Memories - Route 110.png",
      "title": "Emerald Memories: Route 110",
      "category": "Anime",
      "subcategory": "Pokemon",
      "tags": [
        "route 110",
        "nostalgia",
        "retro",
        "cycling",
        "latias",
        "hoenn",
        "pixel art",
        "pokemon",
        "latios",
        "anime",
        "pokemon emerald",
        "Pokemon"
      ],
      "colors": [
        "#bbab75",
        "#dd6130"
      ],
      "resolution": "4096x2304",
      "fileSize": "8.8 MB",
      "variants": {
        "original": {
          "url": "Pokemon/Emerald Memories - Route 110.png",
          "resolution": "4096x2304",
          "size": "8.8 MB"
        }
      },
      "uploadDate": "2026-04-22",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "anya-forger-digital-moodboard",
      "uuid": "65a3018f-a024-5bee-bf62-e6ac29f00ca6",
      "filename": "Spy x Family/Anya Forger Digital Moodboard.png",
      "title": "Anya Forger: Digital Moodboard",
      "category": "Anime",
      "subcategory": "Spy x Family",
      "tags": [
        "pink",
        "moodboard",
        "spy x family",
        "profile card",
        "kawaii",
        "cute",
        "anya forger",
        "anime",
        "digital art",
        "telepath",
        "Spy x Family"
      ],
      "colors": [
        "#fddee2",
        "#e3acb5"
      ],
      "resolution": "4096x2728",
      "fileSize": "11.6 MB",
      "variants": {
        "original": {
          "url": "Spy x Family/Anya Forger Digital Moodboard.png",
          "resolution": "4096x2728",
          "size": "11.6 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "anyas-bubble-blitz",
      "uuid": "6414f1f2-81b8-51f4-9681-10b204760305",
      "filename": "Spy x Family/Anya's Bubble Blitz.png",
      "title": "Anya's Bubble Blitz",
      "category": "Anime",
      "subcategory": "Spy x Family",
      "tags": [
        "anime",
        "spy x family",
        "outdoors",
        "bubbles",
        "cute",
        "anya forger",
        "cheerful",
        "playground",
        "summer",
        "happy",
        "Spy x Family"
      ],
      "colors": [
        "#9dbeba",
        "#576d77"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.5 MB",
      "variants": {
        "original": {
          "url": "Spy x Family/Anya's Bubble Blitz.png",
          "resolution": "4096x2304",
          "size": "2.5 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "anyas-hello-kitty-kingdom",
      "uuid": "dd15d63a-5d70-58fb-a9f3-337f209f1aca",
      "filename": "Spy x Family/Anya's Hello Kitty Kingdom.png",
      "title": "Anya's Hello Kitty Kingdom",
      "category": "Anime",
      "subcategory": "Spy x Family",
      "tags": [
        "pink",
        "spy x family",
        "plushies",
        "room",
        "kawaii",
        "cozy",
        "cute",
        "anya forger",
        "anime",
        "hello kitty",
        "Spy x Family"
      ],
      "colors": [
        "#edd6c1",
        "#b78574"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.1 MB",
      "variants": {
        "original": {
          "url": "Spy x Family/Anya's Hello Kitty Kingdom.png",
          "resolution": "4096x2304",
          "size": "2.1 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "waku-waku-break-a-nod-to-anyas-famous-catchphrase",
      "uuid": "af2e150a-5a01-5884-82df-a0216c78a5b5",
      "filename": "Spy x Family/Waku Waku Break-A nod to Anyas famous catchphrase.png",
      "title": "Anya Forger: Waku Waku Break",
      "category": "Anime",
      "subcategory": "Spy x Family",
      "tags": [
        "pink hair",
        "spy x family",
        "peanuts",
        "waku waku",
        "anya forger",
        "cute",
        "anime",
        "telepath",
        "Spy x Family"
      ],
      "colors": [
        "#efd7c7",
        "#926f64"
      ],
      "resolution": "2304x4096",
      "fileSize": "7.8 MB",
      "variants": {
        "original": {
          "url": "Spy x Family/Waku Waku Break-A nod to Anyas famous catchphrase.png",
          "resolution": "2304x4096",
          "size": "7.8 MB"
        }
      },
      "uploadDate": "2025-12-20",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "toradora",
      "uuid": "a429ceb0-cb85-580c-a472-4bda73da8cc8",
      "filename": "Toradora/Toradora.png",
      "title": "Toradora",
      "category": "Anime",
      "subcategory": "Toradora",
      "tags": [
        "anime",
        "toradora",
        "Toradora"
      ],
      "colors": [
        "#e4b893",
        "#7e5954"
      ],
      "resolution": "4096x2304",
      "fileSize": "10.1 MB",
      "variants": {
        "original": {
          "url": "Toradora/Toradora.png",
          "resolution": "4096x2304",
          "size": "10.1 MB"
        }
      },
      "uploadDate": "2026-03-12",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "weathering-with-you---the-girl-who-changed-the-world",
      "uuid": "db3a4b24-4ece-54ee-b60f-826ea7b06f79",
      "filename": "Weathering-With-You/Weathering with you - The Girl Who Changed the World.png",
      "title": "Weathering With You: The Girl Who Changed the World",
      "category": "Anime",
      "subcategory": "Weathering-With-You",
      "tags": [
        "rooftop",
        "light rays",
        "makoto shinkai",
        "sunshine girl",
        "clouds",
        "dramatic sky",
        "weathering with you",
        "hopeful",
        "anime",
        "romance",
        "Weathering-With-You"
      ],
      "colors": [
        "#b79c8a",
        "#515558"
      ],
      "resolution": "4096x2304",
      "fileSize": "14.7 MB",
      "variants": {
        "original": {
          "url": "Weathering-With-You/Weathering with you - The Girl Who Changed the World.png",
          "resolution": "4096x2304",
          "size": "14.7 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "weathering-with-you---the-great-escape",
      "uuid": "9cb70b18-4ae3-5b89-acb2-d3eca064197a",
      "filename": "Weathering-With-You/Weathering With You - The Great Escape.png",
      "title": "Weathering With You: The Great Escape",
      "category": "Anime",
      "subcategory": "Weathering-With-You",
      "tags": [
        "sky",
        "makoto shinkai",
        "rain",
        "magic",
        "weathering with you",
        "hodaka",
        "hina",
        "sunset",
        "clouds",
        "anime",
        "romance",
        "Weathering-With-You"
      ],
      "colors": [
        "#c4947c",
        "#594a58"
      ],
      "resolution": "4096x2304",
      "fileSize": "13.4 MB",
      "variants": {
        "original": {
          "url": "Weathering-With-You/Weathering With You - The Great Escape.png",
          "resolution": "4096x2304",
          "size": "13.4 MB"
        }
      },
      "uploadDate": "2026-04-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "weathering-with-you",
      "uuid": "f78d63a4-d2c7-5654-b1c4-90f670564bf2",
      "filename": "Weathering-With-You/Weathering With You.png",
      "title": "Weathering With You",
      "category": "Anime",
      "subcategory": "Weathering-With-You",
      "tags": [
        "anime",
        "weathering",
        "you",
        "with",
        "Weathering-With-You"
      ],
      "colors": [
        "#d1cdad",
        "#4d655d"
      ],
      "resolution": "4089x2300",
      "fileSize": "10.8 MB",
      "variants": {
        "original": {
          "url": "Weathering-With-You/Weathering With You.png",
          "resolution": "4089x2300",
          "size": "10.8 MB"
        }
      },
      "uploadDate": "2026-03-12",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "alyas-quiet-morning",
      "uuid": "1e557dd7-331a-570e-b043-4111b1c3cc25",
      "filename": "Lavender Hair Slip Dress Morning.png",
      "title": "Alya's Quiet Morning",
      "category": "Anime",
      "subcategory": null,
      "tags": [
        "elegant",
        "anime girl",
        "bedroom",
        "morning",
        "lace",
        "slip dress",
        "lavender hair",
        "blue eyes",
        "ecchi"
      ],
      "colors": [
        "#d2c1b9",
        "#654d46"
      ],
      "resolution": "4096x2304",
      "fileSize": "6.3 MB",
      "variants": {
        "original": {
          "url": "Lavender Hair Slip Dress Morning.png",
          "resolution": "4096x2304",
          "size": "6.3 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "ninos-morning-brew",
      "uuid": "15be3315-692b-594b-8e4d-72294890c16d",
      "filename": "Pink Hair Morning Coffee.png",
      "title": "Nino's Morning Brew",
      "category": "Anime",
      "subcategory": null,
      "tags": [
        "anime girl",
        "pink hair",
        "open shirt",
        "morning",
        "coffee",
        "cozy",
        "cute",
        "swimsuit",
        "living room",
        "ecchi"
      ],
      "colors": [
        "#d4c6bf",
        "#6f534c"
      ],
      "resolution": "4096x2304",
      "fileSize": "6.3 MB",
      "variants": {
        "original": {
          "url": "Pink Hair Morning Coffee.png",
          "resolution": "4096x2304",
          "size": "6.3 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "alyas-secret-relaxation",
      "uuid": "7a17c650-9fce-5a6d-be25-fa9919b5ac9d",
      "filename": "Silver Hair Yukata Entrance.png",
      "title": "Alya's Secret Relaxation",
      "category": "Anime",
      "subcategory": null,
      "tags": [
        "elegant",
        "anime girl",
        "silver hair",
        "japanese room",
        "yukata",
        "bikini",
        "blue eyes",
        "ecchi"
      ],
      "colors": [
        "#e5c1a6",
        "#69492a"
      ],
      "resolution": "2304x4096",
      "fileSize": "6.4 MB",
      "variants": {
        "original": {
          "url": "Silver Hair Yukata Entrance.png",
          "resolution": "2304x4096",
          "size": "6.4 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "chizurus-private-lesson",
      "uuid": "ee6ddbe7-f69b-5539-8647-7e05c6d3c321",
      "filename": "Beach/Brown Hair Pool Side Bikini.png",
      "title": "Chizuru's Private Lesson",
      "category": "Anime",
      "subcategory": "Beach",
      "tags": [
        "swimming",
        "anime girl",
        "ecchi",
        "pool",
        "sports",
        "bikini",
        "track jacket",
        "brown hair",
        "Beach"
      ],
      "colors": [
        "#b6bcc3",
        "#5a555f"
      ],
      "resolution": "2304x4096",
      "fileSize": "8.2 MB",
      "variants": {
        "original": {
          "url": "Beach/Brown Hair Pool Side Bikini.png",
          "resolution": "2304x4096",
          "size": "8.2 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "killua-obsidian-lightning",
      "uuid": "8bb1b97d-cd80-56b6-8910-a1e047b17239",
      "filename": "Hunter-x-Hunter/Killua Obsidian Lightning.png",
      "title": "Killua Obsidian Lightning",
      "category": "Anime",
      "subcategory": "Hunter-x-Hunter",
      "tags": [
        "killua zoldyck",
        "hunter x hunter",
        "hxh",
        "lightning",
        "obsidian",
        "dark",
        "anime",
        "Hunter-x-Hunter"
      ],
      "colors": [
        "#1f3b72",
        "#242e6b"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.0 MB",
      "variants": {
        "original": {
          "url": "Hunter-x-Hunter/Killua Obsidian Lightning.png",
          "resolution": "2304x4096",
          "size": "2.0 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "king-of-the-pirates-the-journey-ahead",
      "uuid": "09c67c86-ffcf-547d-8512-7bdd00217984",
      "filename": "One-Piece/King of the Pirates The Journey Ahead.png",
      "title": "King of the Pirates: The Journey Ahead",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "luffy",
        "one piece",
        "pirate",
        "journey",
        "king of the pirates",
        "straw hat",
        "anime",
        "One-Piece"
      ],
      "colors": [
        "#2685d1",
        "#828f90"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.1 MB",
      "variants": {
        "original": {
          "url": "One-Piece/King of the Pirates The Journey Ahead.png",
          "resolution": "2304x4096",
          "size": "2.1 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "nami-the-navigators-day-off",
      "uuid": "3b6001da-f6aa-5b84-a015-91eff89b5c9a",
      "filename": "One-Piece/Nami The Navigator's Day Off.png",
      "title": "Nami: The Navigator's Day Off",
      "category": "Anime",
      "subcategory": "One-Piece",
      "tags": [
        "nami",
        "navigator",
        "one piece",
        "day off",
        "orange hair",
        "anime",
        "One-Piece"
      ],
      "colors": [
        "#be6836",
        "#a45f39"
      ],
      "resolution": "4096x2304",
      "fileSize": "1.9 MB",
      "variants": {
        "original": {
          "url": "One-Piece/Nami The Navigator's Day Off.png",
          "resolution": "4096x2304",
          "size": "1.9 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "kalos-champions-resolve",
      "uuid": "a637a7c1-7315-53c7-a071-60a3e3a2dcd8",
      "filename": "Pokemon/Kalos Champion's Resolve.png",
      "title": "Kalos Champion's Resolve",
      "category": "Anime",
      "subcategory": "Pokemon",
      "tags": [
        "pokemon",
        "kalos",
        "champion",
        "resolve",
        "diantha",
        "xy",
        "anime",
        "Pokemon"
      ],
      "colors": [
        "#552019",
        "#5a3a2b"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.9 MB",
      "variants": {
        "original": {
          "url": "Pokemon/Kalos Champion's Resolve.png",
          "resolution": "2304x4096",
          "size": "1.9 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "kalos-queens-quiet-night",
      "uuid": "d64708f5-9999-5690-81bd-d3bf49dca9d7",
      "filename": "Pokemon/Kalos Queen's Quiet Night.png",
      "title": "Kalos Queen's Quiet Night",
      "category": "Anime",
      "subcategory": "Pokemon",
      "tags": [
        "pokemon",
        "kalos queen",
        "serena",
        "aria",
        "xy",
        "night",
        "anime",
        "Pokemon"
      ],
      "colors": [
        "#876651",
        "#987266"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.6 MB",
      "variants": {
        "original": {
          "url": "Pokemon/Kalos Queen's Quiet Night.png",
          "resolution": "2304x4096",
          "size": "1.6 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "mistys-day-off-in-pallet-town",
      "uuid": "577439f4-cf90-58df-ac1e-bc239fef22db",
      "filename": "Pokemon/Misty's Day Off in Pallet Town.png",
      "title": "Misty's Day Off in Pallet Town",
      "category": "Anime",
      "subcategory": "Pokemon",
      "tags": [
        "misty",
        "pokemon",
        "pallet town",
        "day off",
        "red hair",
        "gym leader",
        "anime",
        "Pokemon"
      ],
      "colors": [
        "#696752",
        "#aa9b87"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.5 MB",
      "variants": {
        "original": {
          "url": "Pokemon/Misty's Day Off in Pallet Town.png",
          "resolution": "2304x4096",
          "size": "2.5 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "serenas-summer-selfie",
      "uuid": "6f2ff8f8-9a65-58e8-b378-9dc83a5197b9",
      "filename": "Pokemon/Serena's Summer Selfie.png",
      "title": "Serena's Summer Selfie",
      "category": "Anime",
      "subcategory": "Pokemon",
      "tags": [
        "serena",
        "pokemon",
        "xy",
        "summer",
        "selfie",
        "anime girl",
        "anime",
        "Pokemon"
      ],
      "colors": [
        "#989282",
        "#9f6c54"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.3 MB",
      "variants": {
        "original": {
          "url": "Pokemon/Serena's Summer Selfie.png",
          "resolution": "2304x4096",
          "size": "2.3 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-berry-sweet-brigade",
      "uuid": "213691dd-6d16-5f52-8e38-ba705f9381ef",
      "filename": "Pokemon/The Berry-Sweet Brigade.png",
      "title": "The Berry-Sweet Brigade",
      "category": "Anime",
      "subcategory": "Pokemon",
      "tags": [
        "pokemon",
        "cute",
        "pink",
        "berry",
        "togekiss",
        "clefairy",
        "anime girl",
        "anime",
        "Pokemon"
      ],
      "colors": [
        "#dba5b5",
        "#bb8191"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.0 MB",
      "variants": {
        "original": {
          "url": "Pokemon/The Berry-Sweet Brigade.png",
          "resolution": "2304x4096",
          "size": "2.0 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "chizurus-quiet-campus-morning",
      "uuid": "002dd039-bd39-5739-ac60-720e87a676fc",
      "filename": "Rent-a-Girlfriend/Chizuru's Quiet Campus Morning.png",
      "title": "Chizuru's Quiet Campus Morning",
      "category": "Anime",
      "subcategory": "Rent-a-Girlfriend",
      "tags": [
        "chizuru mizuhara",
        "rent a girlfriend",
        "campus",
        "morning",
        "brown hair",
        "anime girl",
        "anime",
        "Rent-a-Girlfriend"
      ],
      "colors": [
        "#6e8d88",
        "#857e6a"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.0 MB",
      "variants": {
        "original": {
          "url": "Rent-a-Girlfriend/Chizuru's Quiet Campus Morning.png",
          "resolution": "2304x4096",
          "size": "2.0 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "rent-a-girlfriend-springtime-stroll",
      "uuid": "787b24b5-3bb8-5de9-9f6b-1f176c131e82",
      "filename": "Rent-a-Girlfriend/Rent-a-Girlfriend Springtime Stroll.png",
      "title": "Rent-a-Girlfriend: Springtime Stroll",
      "category": "Anime",
      "subcategory": "Rent-a-Girlfriend",
      "tags": [
        "rent a girlfriend",
        "chizuru mizuhara",
        "springtime",
        "stroll",
        "cherry blossoms",
        "anime",
        "Rent-a-Girlfriend"
      ],
      "colors": [
        "#75585c",
        "#58424c"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.2 MB",
      "variants": {
        "original": {
          "url": "Rent-a-Girlfriend/Rent-a-Girlfriend Springtime Stroll.png",
          "resolution": "4096x2304",
          "size": "2.2 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "marin-kitagawa-gyaru-chic",
      "uuid": "f1c4fce4-a110-5a08-b3ba-2838ac206a96",
      "filename": "My-Dress-Up-Darling/Marin Kitagawa Gyaru Chic.png",
      "title": "Marin Kitagawa: Gyaru Chic",
      "category": "Anime",
      "subcategory": "My-Dress-Up-Darling",
      "tags": [
        "marin kitagawa",
        "my dress up darling",
        "sono bisque doll",
        "gyaru",
        "cosplay",
        "blonde hair",
        "anime girl",
        "anime",
        "My-Dress-Up-Darling"
      ],
      "colors": [
        "#c08371",
        "#917073"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.1 MB",
      "variants": {
        "original": {
          "url": "My-Dress-Up-Darling/Marin Kitagawa Gyaru Chic.png",
          "resolution": "2304x4096",
          "size": "2.1 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "my-dress-up-darling-streetwear-chic",
      "uuid": "9bc7b596-c564-5e8c-8368-8e77f6e34759",
      "filename": "My-Dress-Up-Darling/My Dress-Up Darling Streetwear Chic.png",
      "title": "My Dress-Up Darling: Streetwear Chic",
      "category": "Anime",
      "subcategory": "My-Dress-Up-Darling",
      "tags": [
        "marin kitagawa",
        "my dress up darling",
        "streetwear",
        "fashion",
        "anime girl",
        "anime",
        "My-Dress-Up-Darling"
      ],
      "colors": [
        "#84644c",
        "#5a473a"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.8 MB",
      "variants": {
        "original": {
          "url": "My-Dress-Up-Darling/My Dress-Up Darling Streetwear Chic.png",
          "resolution": "4096x2304",
          "size": "2.8 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "tanjiro-flames-amidst-the-azure-night",
      "uuid": "e598bc9a-063b-5eb5-b268-e662530c346d",
      "filename": "Demon-Slayer/Tanjiro Flames Amidst the Azure Night.png",
      "title": "Tanjiro: Flames Amidst the Azure Night",
      "category": "Anime",
      "subcategory": "Demon-Slayer",
      "tags": [
        "tanjiro kamado",
        "demon slayer",
        "kimetsu no yaiba",
        "flames",
        "azure",
        "night",
        "sword",
        "anime",
        "Demon-Slayer"
      ],
      "colors": [
        "#1c2335",
        "#532524"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.6 MB",
      "variants": {
        "original": {
          "url": "Demon-Slayer/Tanjiro Flames Amidst the Azure Night.png",
          "resolution": "2304x4096",
          "size": "2.6 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-burden-of-the-notebook",
      "uuid": "c630d944-4e2d-5cb1-bf8c-ffd1f59fab63",
      "filename": "Death-Note/The Burden of the Notebook.png",
      "title": "The Burden of the Notebook",
      "category": "Anime",
      "subcategory": "Death-Note",
      "tags": [
        "light yagami",
        "death note",
        "ryuk",
        "shinigami",
        "notebook",
        "red moon",
        "kira",
        "anime",
        "Death-Note"
      ],
      "colors": [
        "#391315",
        "#1a080a"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.4 MB",
      "variants": {
        "original": {
          "url": "Death-Note/The Burden of the Notebook.png",
          "resolution": "2304x4096",
          "size": "1.4 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-crimson-moon-of-night-raid",
      "uuid": "9af15053-cb54-59f7-9cf2-d1e227191dac",
      "filename": "Akame-ga-Kill/The Crimson Moon of Night Raid.png",
      "title": "The Crimson Moon of Night Raid",
      "category": "Anime",
      "subcategory": "Akame-ga-Kill",
      "tags": [
        "akame",
        "night raid",
        "akame ga kill",
        "crimson moon",
        "sword",
        "red eyes",
        "anime",
        "Akame-ga-Kill"
      ],
      "colors": [
        "#33080c",
        "#26060b"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.6 MB",
      "variants": {
        "original": {
          "url": "Akame-ga-Kill/The Crimson Moon of Night Raid.png",
          "resolution": "2304x4096",
          "size": "1.6 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-shadow-monarchs-awakening",
      "uuid": "5be1ac16-68b0-5099-b45a-6bdfc57615c5",
      "filename": "Solo-Leveling/The Shadow Monarch's Awakening.png",
      "title": "The Shadow Monarch's Awakening",
      "category": "Anime",
      "subcategory": "Solo-Leveling",
      "tags": [
        "sung jinwoo",
        "solo leveling",
        "shadow monarch",
        "awakening",
        "dark",
        "manhwa",
        "anime",
        "Solo-Leveling"
      ],
      "colors": [
        "#17293d",
        "#2f2c42"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.6 MB",
      "variants": {
        "original": {
          "url": "Solo-Leveling/The Shadow Monarch's Awakening.png",
          "resolution": "2304x4096",
          "size": "2.6 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-world-of-gojo-satoru",
      "uuid": "a3116970-e447-5fd0-beb0-762d53f31321",
      "filename": "Jujutsu-Kaisen/The World of Gojo Satoru.png",
      "title": "The World of Gojo Satoru",
      "category": "Anime",
      "subcategory": "Jujutsu-Kaisen",
      "tags": [
        "gojo satoru",
        "jujutsu kaisen",
        "infinity",
        "blue eyes",
        "white hair",
        "six eyes",
        "anime",
        "Jujutsu-Kaisen"
      ],
      "colors": [
        "#c1bab6",
        "#aea6a1"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.4 MB",
      "variants": {
        "original": {
          "url": "Jujutsu-Kaisen/The World of Gojo Satoru.png",
          "resolution": "4096x2304",
          "size": "2.4 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "your-lie-in-april-healing-the-silence",
      "uuid": "f1fbcbb4-15fe-5598-b56c-3bdd94265c81",
      "filename": "Your-Lie-in-April/Your Lie in April Healing the Silence.png",
      "title": "Your Lie in April: Healing the Silence",
      "category": "Anime",
      "subcategory": "Your-Lie-in-April",
      "tags": [
        "your lie in april",
        "shigatsu wa kimi no uso",
        "kaori",
        "kousei",
        "piano",
        "healing",
        "music",
        "anime",
        "Your-Lie-in-April"
      ],
      "colors": [
        "#c0a7a0",
        "#a59a9f"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.6 MB",
      "variants": {
        "original": {
          "url": "Your-Lie-in-April/Your Lie in April Healing the Silence.png",
          "resolution": "2304x4096",
          "size": "1.6 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "your-name-the-red-thread-of-fate",
      "uuid": "03fb72f0-db98-58e5-80b2-62cc2451086c",
      "filename": "Your-Name/Your Name The Red Thread of Fate.png",
      "title": "Your Name: The Red Thread of Fate",
      "category": "Anime",
      "subcategory": "Your-Name",
      "tags": [
        "your name",
        "kimi no na wa",
        "red thread",
        "fate",
        "taki",
        "mitsuha",
        "makoto shinkai",
        "anime",
        "Your-Name"
      ],
      "colors": [
        "#323968",
        "#644553"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.8 MB",
      "variants": {
        "original": {
          "url": "Your-Name/Your Name The Red Thread of Fate.png",
          "resolution": "2304x4096",
          "size": "1.8 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "zero-two-above-the-clouds",
      "uuid": "f6784a34-b4bd-52b4-b3be-5e246b380fc9",
      "filename": "Darling-in-the-FranXX/Zero Two Above the Clouds.png",
      "title": "Zero Two Above the Clouds",
      "category": "Anime",
      "subcategory": "Darling-in-the-FranXX",
      "tags": [
        "zero two",
        "darling in the franxx",
        "002",
        "pink hair",
        "horns",
        "clouds",
        "anime",
        "Darling-in-the-FranXX"
      ],
      "colors": [
        "#298ff1",
        "#5188d7"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.1 MB",
      "variants": {
        "original": {
          "url": "Darling-in-the-FranXX/Zero Two Above the Clouds.png",
          "resolution": "2304x4096",
          "size": "1.1 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "starlit-chapters-in-the-sun",
      "uuid": "cd3536b8-8e85-5e23-9d58-e1c588af02e5",
      "filename": "Starlit Chapters in the Sun.png",
      "title": "Starlit Chapters in the Sun",
      "category": "Anime",
      "subcategory": null,
      "tags": [
        "anime girl",
        "orange hair",
        "green eyes",
        "book",
        "flowers",
        "meadow",
        "sunshine",
        "cozy",
        "anime"
      ],
      "colors": [
        "#a28c4d",
        "#9f926b"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.0 MB",
      "variants": {
        "original": {
          "url": "Starlit Chapters in the Sun.png",
          "resolution": "2304x4096",
          "size": "2.0 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-bold-sister-nino",
      "uuid": "3fd1052a-e5d5-4d55-9101-c2e8e7fd890b",
      "filename": "Quintessential-Quintuplets/The Bold Sister Nino.png",
      "title": "The Bold Sister Nino",
      "category": "Anime",
      "subcategory": "Quintessential-Quintuplets",
      "tags": [
        "anime",
        "nino nakano",
        "quintessential quintuplets",
        "ecchi",
        "nsfw",
        "bathroom"
      ],
      "colors": [
        "#d4a8b5",
        "#2c3e50"
      ],
      "resolution": "4096x2304",
      "fileSize": "1.7 MB",
      "variants": {
        "original": {
          "url": "Quintessential-Quintuplets/The Bold Sister Nino.png",
          "resolution": "4096x2304",
          "size": "1.7 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "alyas-golden-hour-smile",
      "uuid": "0ba205f3-c14c-4f85-a922-18686c968f08",
      "filename": "Roshidere/Alya's Golden Hour Smile.png",
      "title": "Alya's Golden Hour Smile",
      "category": "Anime",
      "subcategory": "Roshidere",
      "tags": [
        "anime",
        "alya",
        "roshidere",
        "beach",
        "bikini",
        "nsfw",
        "ecchi",
        "sunset",
        "selfie"
      ],
      "colors": [
        "#f4a261",
        "#2c3e50"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.1 MB",
      "variants": {
        "original": {
          "url": "Roshidere/Alya's Golden Hour Smile.png",
          "resolution": "2304x4096",
          "size": "2.1 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "rental-girlfriends-summer-retreat",
      "uuid": "065238e5-64f7-4997-bf4c-42a2f73cf689",
      "filename": "Rent-a-Girlfriend/Rental Girlfriend's Summer Retreat.png",
      "title": "Rental Girlfriend's Summer Retreat",
      "category": "Anime",
      "subcategory": "Rent-a-Girlfriend",
      "tags": [
        "anime",
        "chizuru mizuhara",
        "rent-a-girlfriend",
        "beach",
        "bikini",
        "nsfw",
        "ecchi",
        "summer"
      ],
      "colors": [
        "#87ceeb",
        "#f5e6d3"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.6 MB",
      "variants": {
        "original": {
          "url": "Rent-a-Girlfriend/Rental Girlfriend's Summer Retreat.png",
          "resolution": "2304x4096",
          "size": "1.6 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "yanamis-quiet-shoreline",
      "uuid": "932d88da-09bc-4993-987c-2526c2f75c65",
      "filename": "A-Couple-of-Cuckoos/Yanami's Quiet Shoreline.png",
      "title": "Yanami's Quiet Shoreline",
      "category": "Anime",
      "subcategory": "A-Couple-of-Cuckoos",
      "tags": [
        "anime",
        "yanami anna",
        "a couple of cuckoos",
        "beach",
        "bikini",
        "nsfw",
        "ecchi",
        "summer"
      ],
      "colors": [
        "#7fb3d3",
        "#f5e6d3"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.8 MB",
      "variants": {
        "original": {
          "url": "A-Couple-of-Cuckoos/Yanami's Quiet Shoreline.png",
          "resolution": "2304x4096",
          "size": "1.8 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "yotsubas-summer-energy",
      "uuid": "5cd9d84f-ed40-4f69-81c7-0d52aed43b5b",
      "filename": "Quintessential-Quintuplets/Yotsuba's Summer Energy.png",
      "title": "Yotsuba's Summer Energy",
      "category": "Anime",
      "subcategory": "Quintessential-Quintuplets",
      "tags": [
        "anime",
        "yotsuba nakano",
        "quintessential quintuplets",
        "pool",
        "bikini",
        "nsfw",
        "ecchi",
        "green"
      ],
      "colors": [
        "#27ae60",
        "#f5e6d3"
      ],
      "resolution": "1728x3072",
      "fileSize": "1.0 MB",
      "variants": {
        "original": {
          "url": "Quintessential-Quintuplets/Yotsuba's Summer Energy.png",
          "resolution": "1728x3072",
          "size": "1.0 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "marins-late-night-workshop",
      "uuid": "5cdfda4b-4ae5-4e34-9210-ec5e159563af",
      "filename": "My-Dress-Up-Darling/Marin's Late Night Workshop.png",
      "title": "Marin's Late Night Workshop",
      "category": "Anime",
      "subcategory": "My-Dress-Up-Darling",
      "tags": [
        "anime",
        "marin kitagawa",
        "my dress-up darling",
        "workshop",
        "ecchi",
        "cleavage",
        "nsfw"
      ],
      "colors": [
        "#f5c6b8",
        "#2c3e50"
      ],
      "resolution": "4096x2304",
      "fileSize": "1.9 MB",
      "variants": {
        "original": {
          "url": "My-Dress-Up-Darling/Marin's Late Night Workshop.png",
          "resolution": "4096x2304",
          "size": "1.9 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "yamato-oni-princess-heat",
      "filename": "One-Piece/Yamato Oni Princess Heat.jpg",
      "title": "Yamato's Oni Princess Heat",
      "subcategory": "One-Piece",
      "tags": [
        "anime",
        "yamato",
        "one piece",
        "oni princess",
        "white hair",
        "horns",
        "bedroom",
        "explicit",
        "nsfw",
        "ecchi"
      ],
      "colors": [
        "#e6c5b2",
        "#2c2220"
      ],
      "resolution": "3072x2048",
      "fileSize": "1.0 MB",
      "uuid": "1274d509-4075-4adf-924a-04c42a001394",
      "category": "Anime",
      "variants": {
        "original": {
          "url": "One-Piece/Yamato Oni Princess Heat.jpg",
          "resolution": "3072x2048",
          "size": "1.0 MB"
        }
      },
      "uploadDate": "2026-07-15",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "sunlit-bedroom-duo",
      "filename": "Original/Sunlit Bedroom Duo.png",
      "title": "Sunlit Bedroom Duo",
      "subcategory": "Original",
      "tags": [
        "anime",
        "original character",
        "bedroom",
        "morning light",
        "sportswear",
        "ecchi",
        "nsfw",
        "duo"
      ],
      "colors": [
        "#f2c8a2",
        "#5a3e44"
      ],
      "resolution": "6688x3764",
      "fileSize": "3.7 MB",
      "uuid": "c6b2e786-8cd5-49fe-a7ee-8b922a4035c2",
      "category": "Anime",
      "variants": {
        "original": {
          "url": "Original/Sunlit Bedroom Duo.png",
          "resolution": "6688x3764",
          "size": "3.7 MB"
        }
      },
      "uploadDate": "2026-07-15",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "tropical-water-fight",
      "filename": "Original/Tropical Water Fight.png",
      "title": "Tropical Water Fight",
      "subcategory": "Original",
      "tags": [
        "anime",
        "original character",
        "beach",
        "water gun",
        "green bikini",
        "summer",
        "tropical",
        "ecchi",
        "nsfw"
      ],
      "colors": [
        "#6ed2df",
        "#3a8d69"
      ],
      "resolution": "6688x3764",
      "fileSize": "4.8 MB",
      "uuid": "3a39319c-53b9-48cf-ade0-3916ffa18f0e",
      "category": "Anime",
      "variants": {
        "original": {
          "url": "Original/Tropical Water Fight.png",
          "resolution": "6688x3764",
          "size": "4.8 MB"
        }
      },
      "uploadDate": "2026-07-15",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "game-room-duo-tease",
      "filename": "Original/Game Room Duo Tease.png",
      "title": "Game Room Duo Tease",
      "subcategory": "Original",
      "tags": [
        "anime",
        "original character",
        "game room",
        "sportswear",
        "bedroom",
        "ecchi",
        "nsfw",
        "duo"
      ],
      "colors": [
        "#d98483",
        "#2c1f24"
      ],
      "resolution": "6688x3764",
      "fileSize": "3.9 MB",
      "uuid": "9ef2968e-7e56-4a94-a544-b1692b25f41f",
      "category": "Anime",
      "variants": {
        "original": {
          "url": "Original/Game Room Duo Tease.png",
          "resolution": "6688x3764",
          "size": "3.9 MB"
        }
      },
      "uploadDate": "2026-07-15",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "chizuru-sunset-beach-dare",
      "filename": "Rent-a-Girlfriend/Chizuru Sunset Beach Dare.png",
      "title": "Chizuru's Sunset Beach Dare",
      "subcategory": "Rent-a-Girlfriend",
      "tags": [
        "anime",
        "chizuru mizuhara",
        "rent-a-girlfriend",
        "beach",
        "sunset",
        "black bikini",
        "umbrella",
        "ecchi",
        "nsfw"
      ],
      "colors": [
        "#f2a45c",
        "#392422"
      ],
      "resolution": "6688x3764",
      "fileSize": "4.6 MB",
      "uuid": "28549417-aa97-43fc-a45c-41f398d6f4ca",
      "category": "Anime",
      "variants": {
        "original": {
          "url": "Rent-a-Girlfriend/Chizuru Sunset Beach Dare.png",
          "resolution": "6688x3764",
          "size": "4.6 MB"
        }
      },
      "uploadDate": "2026-07-15",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "chizuru-pink-bikini-morning",
      "filename": "Rent-a-Girlfriend/Chizuru Pink Bikini Morning.png",
      "title": "Chizuru's Pink Bikini Morning",
      "subcategory": "Rent-a-Girlfriend",
      "tags": [
        "anime",
        "chizuru mizuhara",
        "rent-a-girlfriend",
        "pink bikini",
        "bedroom",
        "morning",
        "ecchi",
        "nsfw"
      ],
      "colors": [
        "#f0c8bd",
        "#8c4a4d"
      ],
      "resolution": "6688x3764",
      "fileSize": "3.2 MB",
      "uuid": "b250be30-abaf-4c1d-a447-735ae9f133c2",
      "category": "Anime",
      "variants": {
        "original": {
          "url": "Rent-a-Girlfriend/Chizuru Pink Bikini Morning.png",
          "resolution": "6688x3764",
          "size": "3.2 MB"
        }
      },
      "uploadDate": "2026-07-15",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "chizurus-bashful-reveal",
      "uuid": "19299939-6e6e-41ff-abc9-f5e8450625a5",
      "filename": "Rent-a-Girlfriend/Chizuru Mizuhara_1786697279772.png",
      "title": "Chizuru's Bashful Reveal",
      "category": "Anime",
      "subcategory": "Rent-a-Girlfriend",
      "tags": [
        "anime",
        "chizuru mizuhara",
        "rent-a-girlfriend",
        "nude",
        "nsfw",
        "explicit",
        "blush"
      ],
      "colors": [
        "#c9ba9a",
        "#fee9de"
      ],
      "resolution": "5120x7680",
      "fileSize": "1.8 MB",
      "variants": {
        "original": {
          "url": "Rent-a-Girlfriend/Chizuru Mizuhara_1786697279772.png",
          "resolution": "5120x7680",
          "size": "1.8 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "mamis-hot-spring-blush",
      "uuid": "12ef1f83-5ed8-40f4-9974-16b783469cf2",
      "filename": "Rent-a-Girlfriend/mami_nanami__steam____rent_a_girlfriend__ai_art__by_cosplaymakin_dmmbzqs-pre.jpg",
      "title": "Mami's Hot Spring Blush",
      "category": "Anime",
      "subcategory": "Rent-a-Girlfriend",
      "tags": [
        "anime",
        "mami nanami",
        "rent-a-girlfriend",
        "hot spring",
        "nude",
        "nsfw",
        "explicit"
      ],
      "colors": [
        "#cda089",
        "#a67a67"
      ],
      "resolution": "4380x2920",
      "fileSize": "1.0 MB",
      "variants": {
        "original": {
          "url": "Rent-a-Girlfriend/mami_nanami__steam____rent_a_girlfriend__ai_art__by_cosplaymakin_dmmbzqs-pre.jpg",
          "resolution": "4380x2920",
          "size": "1.0 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "aquas-blushing-close-up",
      "uuid": "a9a5eef7-e68b-4ac6-9623-7ca10b904a95",
      "filename": "Konosuba/aqua__konosuba__ai_art__by_cosplaymakin_dmclqag-414w-2x.jpg",
      "title": "Aqua's Blushing Close-Up",
      "category": "Anime",
      "subcategory": "Konosuba",
      "tags": [
        "anime",
        "aqua",
        "konosuba",
        "ecchi",
        "nsfw",
        "explicit",
        "close-up"
      ],
      "colors": [
        "#a3c1c1",
        "#d9b5a6"
      ],
      "resolution": "2796x4968",
      "fileSize": "1.0 MB",
      "variants": {
        "original": {
          "url": "Konosuba/aqua__konosuba__ai_art__by_cosplaymakin_dmclqag-414w-2x.jpg",
          "resolution": "2796x4968",
          "size": "1.0 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    }
  ,
    {
      "id": "ruby-x-jaune",
      "uuid": "3fd743f2-e789-40a7-8316-0aa393c95fef",
      "filename": "RWBY/ruby-x-jaune.png",
      "title": "Ruby x Jaune",
      "category": "Anime",
      "subcategory": "RWBY",
      "tags": [
        "rwby"
      ],
      "colors": [
        "#F9E6D8",
        "#E2EBE5"
      ],
      "resolution": "3312x2484",
      "fileSize": "8.0 MB",
      "variants": {
        "original": {
          "url": "RWBY/ruby-x-jaune.png",
          "resolution": "3312x2484",
          "size": "8.0 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "marin-x-gojo",
      "uuid": "10c16e27-afec-4940-9556-d1f37b19cc5b",
      "filename": "My-Dress-Up-Darling/marin-x-gojo.jpg",
      "title": "Marin x Gojo",
      "category": "Anime",
      "subcategory": "My-Dress-Up-Darling",
      "tags": [
        "marin kitagawa",
        "pussy-licking",
        "wakana gojo"
      ],
      "colors": [
        "#F6E3D5",
        "#DAC184"
      ],
      "resolution": "3304x1984",
      "fileSize": "0.5 MB",
      "variants": {
        "original": {
          "url": "My-Dress-Up-Darling/marin-x-gojo.jpg",
          "resolution": "3304x1984",
          "size": "0.5 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "megumin-face-sitting",
      "uuid": "70d9f61f-f771-428c-bbbf-3cb41d50864e",
      "filename": "KonoSuba: God's Blessing on This Wonderful World!/megumin-face-sitting.jpg",
      "title": "Megumin Face-sitting",
      "category": "Anime",
      "subcategory": "KonoSuba: God's Blessing on This Wonderful World!",
      "tags": [
        "megumin",
        "face-sitting",
        "anime"
      ],
      "colors": [
        "#F6DCCA",
        "#85724A"
      ],
      "resolution": "1680x2800",
      "fileSize": "0.5 MB",
      "variants": {
        "original": {
          "url": "KonoSuba: God's Blessing on This Wonderful World!/megumin-face-sitting.jpg",
          "resolution": "1680x2800",
          "size": "0.5 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "ninos-secret-room-home-alone-edition",
      "uuid": "c02362b9-142f-4458-8def-6192df39d750",
      "filename": "The Quintessential Quintuplets/ninos-secret-room-home-alone-edition.jpg",
      "title": "Nino's Secret Room: Home Alone Edition",
      "category": "Anime",
      "subcategory": "The Quintessential Quintuplets",
      "tags": [
        "nino nakano",
        "sexy",
        "lace bra"
      ],
      "colors": [
        "#EED9CE",
        "#312B30"
      ],
      "resolution": "3308x4576",
      "fileSize": "1.5 MB",
      "variants": {
        "original": {
          "url": "The Quintessential Quintuplets/ninos-secret-room-home-alone-edition.jpg",
          "resolution": "3308x4576",
          "size": "1.5 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "ruby-and-velvets-shower-time",
      "uuid": "fc144655-f5f8-4ca9-b82a-a4234225008d",
      "filename": "RWBY/ruby-and-velvets-shower-time.png",
      "title": "Ruby and Velvet's Shower Time",
      "category": "Anime",
      "subcategory": "RWBY",
      "tags": [
        "rwby",
        "ruby",
        "velvet",
        "boobs",
        "nipples",
        "bath"
      ],
      "colors": [
        "#C9DEE2",
        "#FAE0D6"
      ],
      "resolution": "2996x2248",
      "fileSize": "7.0 MB",
      "variants": {
        "original": {
          "url": "RWBY/ruby-and-velvets-shower-time.png",
          "resolution": "2996x2248",
          "size": "7.0 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "playing-with-dianes-boobies",
      "uuid": "7aa79857-873e-4926-b66b-b0553c8aea1f",
      "filename": "Seven Deadly Sins/playing-with-dianes-boobies.png",
      "title": "Playing With Diane's Boobies",
      "category": "Anime",
      "subcategory": "Seven Deadly Sins",
      "tags": [
        "anime",
        "diane",
        "boobs",
        "nipples"
      ],
      "colors": [
        "#B28475",
        "#271712"
      ],
      "resolution": "1132x2000",
      "fileSize": "2.5 MB",
      "variants": {
        "original": {
          "url": "Seven Deadly Sins/playing-with-dianes-boobies.png",
          "resolution": "1132x2000",
          "size": "2.5 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "the-dragon-witch-in-solitude",
      "uuid": "1a1c8327-eab2-40ef-bacc-ae58f2023da1",
      "filename": "Fate/Grand Order/the-dragon-witch-in-solitude.png",
      "title": "The Dragon Witch in Solitude",
      "category": "Anime",
      "subcategory": "Fate/Grand Order",
      "tags": [
        "anime",
        "fate/grand order",
        "the dragon witch",
        "naked",
        "blindfolded",
        "boobs",
        "nipples"
      ],
      "colors": [
        "#F0D8D3",
        "#2C3E68"
      ],
      "resolution": "1860x2800",
      "fileSize": "5.5 MB",
      "variants": {
        "original": {
          "url": "Fate/Grand Order/the-dragon-witch-in-solitude.png",
          "resolution": "1860x2800",
          "size": "5.5 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
        {
      "id": "milim-nava-a-moment-of-mischief",
      "uuid": "33fc7971-6a53-4d03-9703-6ac0f92d14e1",
      "filename": "That Time I Got Reincarnated as a Slime/milim-nava-a-moment-of-mischief.png",
      "title": "Milim Nava: A Moment of Mischief",
      "category": "Anime",
      "subcategory": "That Time I Got Reincarnated as a Slime",
      "tags": [
        "anime",
        "boobs",
        "milim nava"
      ],
      "colors": [
        "#DD8984",
        "#FAEBE2"
      ],
      "resolution": "1132x2000",
      "fileSize": "2.8 MB",
      "variants": {
        "original": {
          "url": "That Time I Got Reincarnated as a Slime/milim-nava-a-moment-of-mischief.png",
          "resolution": "1132x2000",
          "size": "2.8 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "mistys-carefree-spirit",
      "uuid": "e8134df9-b0cc-4191-85ce-44c947c3b195",
      "filename": "Pokémon/mistys-carefree-spirit.png",
      "title": "Misty's Carefree Spirit",
      "category": "Anime",
      "subcategory": "Pokémon",
      "tags": [
        "misty",
        "naked",
        "boobs",
        "pussy",
        "pokémon"
      ],
      "colors": [
        "#E7CEC5",
        "#CA9783"
      ],
      "resolution": "2100x2800",
      "fileSize": "6.8 MB",
      "variants": {
        "original": {
          "url": "Pokémon/mistys-carefree-spirit.png",
          "resolution": "2100x2800",
          "size": "6.8 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "yor-forger-the-pink-menace",
      "uuid": "aee830b6-4c20-45d7-94f0-27530c8156ae",
      "filename": "Spy x Family/yor-forger-the-pink-menace.png",
      "title": "Yor Forger: The Pink Menace",
      "category": "Anime",
      "subcategory": "Spy x Family",
      "tags": [
        "anime",
        "yor forger",
        "naked",
        "spy x family",
        "boobs",
        "nipples",
        "pussy"
      ],
      "colors": [
        "#E9DBD6",
        "#442F2B"
      ],
      "resolution": "3000x2164",
      "fileSize": "6.4 MB",
      "variants": {
        "original": {
          "url": "Spy x Family/yor-forger-the-pink-menace.png",
          "resolution": "3000x2164",
          "size": "6.4 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "yor-forger-the-destroyers-gaze",
      "uuid": "629197d0-f5a1-4c44-a9f8-993c314319f7",
      "filename": "Spy x Family/yor-forger-the-destroyers-gaze.png",
      "title": "Yor Forger: The Destroyer's Gaze",
      "category": "Anime",
      "subcategory": "Spy x Family",
      "tags": [
        "anime",
        "yor forger",
        "spy x family",
        "boobs",
        "nipples"
      ],
      "colors": [
        "#D09F8E",
        "#F2E4DB"
      ],
      "resolution": "3312x1872",
      "fileSize": "6.3 MB",
      "variants": {
        "original": {
          "url": "Spy x Family/yor-forger-the-destroyers-gaze.png",
          "resolution": "3312x1872",
          "size": "6.3 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "yui-and-hikigaya-afternoon-in-the-clubroom",
      "uuid": "6c697b55-fdd8-4073-827d-76fa4d12ef2c",
      "filename": "My Teen Romantic Comedy SNAFU - Oregairu/yui-and-hikigaya-afternoon-in-the-clubroom.png",
      "title": "Yui and Hikigaya: Afternoon in the Clubroom",
      "category": "Anime",
      "subcategory": "My Teen Romantic Comedy SNAFU - Oregairu",
      "tags": [
        "anime",
        "boobs sucking",
        "nipples",
        "boobs"
      ],
      "colors": [
        "#888888",
        "#444444"
      ],
      "resolution": "4092x2800",
      "fileSize": "13.1 MB",
      "variants": {
        "original": {
          "url": "My Teen Romantic Comedy SNAFU - Oregairu/yui-and-hikigaya-afternoon-in-the-clubroom.png",
          "resolution": "4092x2800",
          "size": "13.1 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    }],
  "ecchi": [
    {
      "id": "violet-haze",
      "uuid": "0896484f-586a-5c08-b722-125e025d162f",
      "filename": "Black Hair Kimono Beauty.png",
      "title": "Violet Haze",
      "category": "Ecchi",
      "subcategory": null,
      "tags": [
        "elegant",
        "anime girl",
        "kimono",
        "black hair",
        "floral",
        "japanese",
        "cleavage",
        "purple accents",
        "ecchi"
      ],
      "colors": [
        "#c5b2b8",
        "#4b4354"
      ],
      "resolution": "2304x4096",
      "fileSize": "9.1 MB",
      "variants": {
        "original": {
          "url": "Black Hair Kimono Beauty.png",
          "resolution": "2304x4096",
          "size": "9.1 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "onsen-evening",
      "uuid": "280610ef-cf89-546c-82a8-0a733eff3fd3",
      "filename": "Black Hair Onsen Bikini.png",
      "title": "Onsen Evening",
      "category": "Ecchi",
      "subcategory": null,
      "tags": [
        "anime girl",
        "onsen",
        "intimate",
        "japanese room",
        "black hair",
        "warm",
        "purple",
        "bikini",
        "ecchi"
      ],
      "colors": [
        "#d5a78b",
        "#503621"
      ],
      "resolution": "2304x4096",
      "fileSize": "6.9 MB",
      "variants": {
        "original": {
          "url": "Black Hair Onsen Bikini.png",
          "resolution": "2304x4096",
          "size": "6.9 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "summer-streetwear",
      "uuid": "9a90ef1e-5730-5d15-93fc-4bca1bd9f70d",
      "filename": "Black Hair Street Style Casual.png",
      "title": "Summer Streetwear",
      "category": "Ecchi",
      "subcategory": null,
      "tags": [
        "anime girl",
        "crop top",
        "black hair",
        "street style",
        "casual",
        "cute",
        "shorts",
        "denim jacket",
        "ecchi"
      ],
      "colors": [
        "#f4efef",
        "#7c7378"
      ],
      "resolution": "2304x4096",
      "fileSize": "7.2 MB",
      "variants": {
        "original": {
          "url": "Black Hair Street Style Casual.png",
          "resolution": "2304x4096",
          "size": "7.2 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "candid-moment",
      "uuid": "acf8aa8b-35a8-52ad-af7c-ca33a3458505",
      "filename": "Brown Hair Billiards Lean.png",
      "title": "Candid Moment",
      "category": "Ecchi",
      "subcategory": null,
      "tags": [
        "anime girl",
        "billiards",
        "ecchi",
        "cleavage",
        "cute",
        "flirty",
        "bra",
        "shorts",
        "brown hair"
      ],
      "colors": [
        "#ae9d87",
        "#483935"
      ],
      "resolution": "4096x2304",
      "fileSize": "5.8 MB",
      "variants": {
        "original": {
          "url": "Brown Hair Billiards Lean.png",
          "resolution": "4096x2304",
          "size": "5.8 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "midnight-lace-and-rose",
      "uuid": "538bbed5-7756-5089-8596-9f64de3bfca0",
      "filename": "Pink Catgirl Morning Stretch.png",
      "title": "Midnight Lace & Rose",
      "category": "Ecchi",
      "subcategory": null,
      "tags": [
        "twintails",
        "pink hair",
        "catgirl",
        "neko",
        "bedroom",
        "cat ears",
        "cute",
        "blushing",
        "lingerie",
        "ecchi"
      ],
      "colors": [
        "#c8afa6",
        "#72504b"
      ],
      "resolution": "4096x2304",
      "fileSize": "6.0 MB",
      "variants": {
        "original": {
          "url": "Pink Catgirl Morning Stretch.png",
          "resolution": "4096x2304",
          "size": "6.0 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "pink-hair-summer-blossom",
      "uuid": "2012496d-5846-5bd6-be1a-ca103d980af0",
      "filename": "Pink Hair Summer Blossom.png",
      "title": "Pink Hair Summer Blossom",
      "category": "Ecchi",
      "subcategory": null,
      "tags": [
        "anime girl",
        "pink hair",
        "bedroom",
        "cute",
        "blushing",
        "lingerie",
        "suggestive",
        "ecchi"
      ],
      "colors": [
        "#c9aeae",
        "#7d5a5e"
      ],
      "resolution": "4096x2304",
      "fileSize": "5.8 MB",
      "variants": {
        "original": {
          "url": "Pink Hair Summer Blossom.png",
          "resolution": "4096x2304",
          "size": "5.8 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "violet-pulse",
      "uuid": "63dce1cc-4c31-568f-abe3-b7013dc922b9",
      "filename": "Purple Hair Nurse Outfit.png",
      "title": "Violet Pulse",
      "category": "Ecchi",
      "subcategory": null,
      "tags": [
        "anime girl",
        "costume",
        "flirty",
        "black hair",
        "nurse",
        "hospital",
        "purple eyes",
        "roleplay",
        "ecchi"
      ],
      "colors": [
        "#d0cbce",
        "#625b63"
      ],
      "resolution": "2304x4096",
      "fileSize": "7.3 MB",
      "variants": {
        "original": {
          "url": "Purple Hair Nurse Outfit.png",
          "resolution": "2304x4096",
          "size": "7.3 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "golden-wink",
      "uuid": "18f1fac1-66fa-5127-b6de-3d14b47f574f",
      "filename": "Yellow Bikini Summer Wink.png",
      "title": "Golden Wink",
      "category": "Ecchi",
      "subcategory": null,
      "tags": [
        "anime girl",
        "flirty",
        "ecchi",
        "summer",
        "cute",
        "yellow bikini",
        "wink",
        "midriff",
        "brown hair"
      ],
      "colors": [
        "#e4cabd",
        "#8c6c62"
      ],
      "resolution": "2304x4096",
      "fileSize": "6.3 MB",
      "variants": {
        "original": {
          "url": "Yellow Bikini Summer Wink.png",
          "resolution": "2304x4096",
          "size": "6.3 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "cerulean-horizon",
      "uuid": "e106794a-a845-5b9a-8528-b49f97d09300",
      "filename": "Beach/Blonde Beach Heartbeat.png",
      "title": "Cerulean Horizon",
      "category": "Ecchi",
      "subcategory": "Beach",
      "tags": [
        "anime girl",
        "ocean",
        "summer",
        "cute",
        "sunglasses",
        "beach",
        "blonde hair",
        "bikini",
        "ecchi",
        "Beach"
      ],
      "colors": [
        "#cfcccf",
        "#987a7e"
      ],
      "resolution": "2304x4096",
      "fileSize": "8.6 MB",
      "variants": {
        "original": {
          "url": "Beach/Blonde Beach Heartbeat.png",
          "resolution": "2304x4096",
          "size": "8.6 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "summer-splash-showdown",
      "uuid": "d6ce0d1a-d003-5a41-b8ad-853ff3ebb0a1",
      "filename": "Beach/Brown Hair Beach Water Fight.png",
      "title": "Summer Splash Showdown",
      "category": "Ecchi",
      "subcategory": "Beach",
      "tags": [
        "anime girl",
        "water gun",
        "energetic",
        "fun",
        "ecchi",
        "summer",
        "beach",
        "ocean",
        "bikini",
        "brown hair",
        "Beach"
      ],
      "colors": [
        "#bac9d7",
        "#627292"
      ],
      "resolution": "4096x2304",
      "fileSize": "10.0 MB",
      "variants": {
        "original": {
          "url": "Beach/Brown Hair Beach Water Fight.png",
          "resolution": "4096x2304",
          "size": "10.0 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "azure-shores-seduction",
      "uuid": "202fbf40-8ecf-5ac7-940c-0afcdc37cb95",
      "filename": "Beach/Dark Hair Beach Back View.png",
      "title": "Azure Shores Seduction",
      "category": "Ecchi",
      "subcategory": "Beach",
      "tags": [
        "anime girl",
        "black hair",
        "wet",
        "back view",
        "summer",
        "beach",
        "ocean",
        "bikini",
        "ecchi",
        "Beach"
      ],
      "colors": [
        "#cebeb1",
        "#4f4d4c"
      ],
      "resolution": "2304x4096",
      "fileSize": "7.8 MB",
      "variants": {
        "original": {
          "url": "Beach/Dark Hair Beach Back View.png",
          "resolution": "2304x4096",
          "size": "7.8 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "the-cats-meow",
      "uuid": "92953f37-a5aa-5be7-a76c-87ed227af63e",
      "filename": "Neko/Brown Catgirl Playful Pose.png",
      "title": "The Cat's Meow",
      "category": "Ecchi",
      "subcategory": "Neko",
      "tags": [
        "twintails",
        "catgirl",
        "neko",
        "ecchi",
        "cat ears",
        "cute",
        "bikini",
        "cat themed",
        "playful",
        "brown hair",
        "Neko"
      ],
      "colors": [
        "#d6af9b",
        "#61413c"
      ],
      "resolution": "1764x3136",
      "fileSize": "4.0 MB",
      "variants": {
        "original": {
          "url": "Neko/Brown Catgirl Playful Pose.png",
          "resolution": "1764x3136",
          "size": "4.0 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "a-sultry-neko-welcome",
      "uuid": "2ed9fd13-ff9b-57fd-843f-1a689607e6e2",
      "filename": "Neko/Dark Catgirl Black Bikini.png",
      "title": "A Sultry Neko Welcome",
      "category": "Ecchi",
      "subcategory": "Neko",
      "tags": [
        "twintails",
        "catgirl",
        "neko",
        "blushing",
        "cat ears",
        "black hair",
        "bikini",
        "purple eyes",
        "ecchi",
        "Neko"
      ],
      "colors": [
        "#d2b8b2",
        "#493c45"
      ],
      "resolution": "1720x3056",
      "fileSize": "3.8 MB",
      "variants": {
        "original": {
          "url": "Neko/Dark Catgirl Black Bikini.png",
          "resolution": "1720x3056",
          "size": "3.8 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "violet-haze-seduction",
      "uuid": "3c0c1a72-683e-5888-ad89-1c2decd912cb",
      "filename": "Neko/Dark Catgirl Popsicle Summer.png",
      "title": "Violet Haze Seduction",
      "category": "Ecchi",
      "subcategory": "Neko",
      "tags": [
        "catgirl",
        "neko",
        "cat ears",
        "black hair",
        "popsicle",
        "summer",
        "sunglasses",
        "flirty",
        "bikini",
        "ecchi",
        "Neko"
      ],
      "colors": [
        "#f0e7e6",
        "#655b69"
      ],
      "resolution": "2304x4096",
      "fileSize": "6.6 MB",
      "variants": {
        "original": {
          "url": "Neko/Dark Catgirl Popsicle Summer.png",
          "resolution": "2304x4096",
          "size": "6.6 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "the-nekos-smile",
      "uuid": "9d9f9370-73d7-50eb-8068-ed6007b95ee3",
      "filename": "Neko/Silver Catgirl Close-Up.png",
      "title": "The Neko's Smile",
      "category": "Ecchi",
      "subcategory": "Neko",
      "tags": [
        "twintails",
        "close-up",
        "silver hair",
        "catgirl",
        "neko",
        "cat ears",
        "cute",
        "bikini",
        "blue eyes",
        "ecchi",
        "Neko"
      ],
      "colors": [
        "#d0bbb8",
        "#745e5e"
      ],
      "resolution": "1764x3136",
      "fileSize": "4.1 MB",
      "variants": {
        "original": {
          "url": "Neko/Silver Catgirl Close-Up.png",
          "resolution": "1764x3136",
          "size": "4.1 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "silver-frost-seduction",
      "uuid": "c72cd8e8-8601-5314-9461-3ddf814782d6",
      "filename": "Neko/Silver Wolf Girl Urban Edge.png",
      "title": "Silver Frost Seduction",
      "category": "Ecchi",
      "subcategory": "Neko",
      "tags": [
        "anime girl",
        "silver hair",
        "crop top",
        "urban",
        "wolf ears",
        "cool",
        "turtleneck",
        "midriff",
        "ecchi",
        "Neko"
      ],
      "colors": [
        "#dbd6d7",
        "#3d434d"
      ],
      "resolution": "2304x4096",
      "fileSize": "5.2 MB",
      "variants": {
        "original": {
          "url": "Neko/Silver Wolf Girl Urban Edge.png",
          "resolution": "2304x4096",
          "size": "5.2 MB"
        }
      },
      "uploadDate": "2026-05-01",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "twilight-shoreline-radiance",
      "uuid": "04bf19d4-2df7-42e0-96d4-c947818f6c71",
      "filename": "Beach/Twilight Shoreline Radiance.png",
      "title": "Twilight Shoreline Radiance",
      "category": "Ecchi",
      "subcategory": "Beach",
      "tags": [
        "anime",
        "beach",
        "bikini",
        "nsfw",
        "ecchi",
        "sunset",
        "white hair",
        "summer"
      ],
      "colors": [
        "#f4a261",
        "#2c3e50"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.7 MB",
      "variants": {
        "original": {
          "url": "Beach/Twilight Shoreline Radiance.png",
          "resolution": "2304x4096",
          "size": "1.7 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "silver-locks-bare-embrace",
      "uuid": "7c44d508-111d-4155-93ce-ab5f763d44ad",
      "filename": "Bedroom/09bd0601ce7a87bf28ace01e95c089e1422c25b1baf298243c9bcd96499091cc.jpeg",
      "title": "Silver Locks Bare Embrace",
      "category": "Ecchi",
      "subcategory": "Bedroom",
      "tags": [
        "anime",
        "white hair",
        "nude",
        "nsfw",
        "explicit",
        "bedroom",
        "blush"
      ],
      "colors": [
        "#88625e",
        "#78504c"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.5 MB",
      "variants": {
        "original": {
          "url": "Bedroom/09bd0601ce7a87bf28ace01e95c089e1422c25b1baf298243c9bcd96499091cc.jpeg",
          "resolution": "1728x3072",
          "size": "0.5 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "bound-maids-service",
      "uuid": "2bb29e9f-9ad6-4e39-bdfa-f058e93b3a48",
      "filename": "Maid/6961a21d83d8ed3b822da152d9ec50938a247232964ac1806e518218a7a5c93b.png",
      "title": "Bound Maid's Service",
      "category": "Ecchi",
      "subcategory": "Maid",
      "tags": [
        "anime",
        "maid",
        "bondage",
        "nsfw",
        "explicit",
        "tray",
        "pantyhose"
      ],
      "colors": [
        "#c8bc9c",
        "#604c38"
      ],
      "resolution": "3312x4968",
      "fileSize": "1.0 MB",
      "variants": {
        "original": {
          "url": "Maid/6961a21d83d8ed3b822da152d9ec50938a247232964ac1806e518218a7a5c93b.png",
          "resolution": "3312x4968",
          "size": "1.0 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "golden-hour-bedroom-passion",
      "uuid": "096b574d-8e04-4c3a-a975-9e634ac85a83",
      "filename": "Bedroom/aacccff6a5e3a72bf70437205fa537277e34912bf8340607a1e4631ab5303b6f.jpeg",
      "title": "Golden Hour Bedroom Passion",
      "category": "Ecchi",
      "subcategory": "Bedroom",
      "tags": [
        "anime",
        "blonde",
        "nude",
        "nsfw",
        "explicit",
        "bedroom",
        "couple"
      ],
      "colors": [
        "#d0a37d",
        "#806054"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.4 MB",
      "variants": {
        "original": {
          "url": "Bedroom/aacccff6a5e3a72bf70437205fa537277e34912bf8340607a1e4631ab5303b6f.jpeg",
          "resolution": "1728x3072",
          "size": "0.4 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "grayscale-bathhouse-desire",
      "uuid": "d8522c64-5afc-4e71-855b-5f7f76f30eca",
      "filename": "Bathroom/download (3).jpg",
      "title": "Grayscale Bathhouse Desire",
      "category": "Ecchi",
      "subcategory": "Bathroom",
      "tags": [
        "anime",
        "monochrome",
        "bathroom",
        "nsfw",
        "explicit",
        "shower"
      ],
      "colors": [
        "#3b393e",
        "#58575d"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.5 MB",
      "variants": {
        "original": {
          "url": "Bathroom/download (3).jpg",
          "resolution": "1728x3072",
          "size": "0.5 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
            {
      "id": "detention-room-desire",
      "uuid": "4570c23e-fb78-4434-86d4-6331b45e2157",
      "filename": "Bondage/56ee55f2957dd2a47ee8f97e6e30490f53266b574a7af5707d8219541d01fa7a.png",
      "title": "Detention Room Desire",
      "category": "Ecchi",
      "subcategory": "Bondage",
      "tags": [
        "anime",
        "bondage",
        "rope",
        "nsfw",
        "explicit",
        "uniform"
      ],
      "colors": [
        "#dec7c0",
        "#796b6b"
      ],
      "resolution": "3312x4968",
      "fileSize": "1.2 MB",
      "variants": {
        "original": {
          "url": "Bondage/56ee55f2957dd2a47ee8f97e6e30490f53266b574a7af5707d8219541d01fa7a.png",
          "resolution": "3312x4968",
          "size": "1.2 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "catgirls-sweet-surrender",
      "uuid": "3079cf15-b0ee-4eb7-a30e-7e2366c30dea",
      "filename": "Catgirl/7521aa741630fd1f0071a4c3ef993e5c7b2ff0f1e360a38bd41d6de70610d00a.jpeg",
      "title": "Catgirl's Sweet Surrender",
      "category": "Ecchi",
      "subcategory": "Catgirl",
      "tags": [
        "anime",
        "catgirl",
        "nude",
        "nsfw",
        "explicit",
        "bedroom"
      ],
      "colors": [
        "#261f26",
        "#bb9c9c"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.4 MB",
      "variants": {
        "original": {
          "url": "Catgirl/7521aa741630fd1f0071a4c3ef993e5c7b2ff0f1e360a38bd41d6de70610d00a.jpeg",
          "resolution": "1728x3072",
          "size": "0.4 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "blonde-bob-deepthroat-bliss",
      "uuid": "cd4875b3-34a3-41f3-af1e-c36f4c1d977c",
      "filename": "Bedroom/b5f04f0933cdb874f1b93032c658b9428dd420cfb8f0165e78277da292c7f5c5.jpeg",
      "title": "Blonde Bob Deepthroat Bliss",
      "category": "Ecchi",
      "subcategory": "Bedroom",
      "tags": [
        "anime",
        "blonde",
        "oral",
        "nsfw",
        "explicit",
        "close-up"
      ],
      "colors": [
        "#f9e0d2",
        "#83737a"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.5 MB",
      "variants": {
        "original": {
          "url": "Bedroom/b5f04f0933cdb874f1b93032c658b9428dd420cfb8f0165e78277da292c7f5c5.jpeg",
          "resolution": "1728x3072",
          "size": "0.5 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "facial-finish-blush",
      "uuid": "c234b746-2d03-41df-97bf-fbd2a1d58c4c",
      "filename": "Bedroom/ddf5a91da3e8aa45dadf43d473bfce3fd9c794b9c6c8db2352713cc8e1aff827.png",
      "title": "Facial Finish Blush",
      "category": "Ecchi",
      "subcategory": "Bedroom",
      "tags": [
        "anime",
        "brunette",
        "facial",
        "nsfw",
        "explicit",
        "close-up"
      ],
      "colors": [
        "#bf8e85",
        "#daaba2"
      ],
      "resolution": "3312x4968",
      "fileSize": "1.2 MB",
      "variants": {
        "original": {
          "url": "Bedroom/ddf5a91da3e8aa45dadf43d473bfce3fd9c794b9c6c8db2352713cc8e1aff827.png",
          "resolution": "3312x4968",
          "size": "1.2 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "blonde-deepthroat-delight",
      "uuid": "cdffc53d-6466-471a-b8da-400acf28a8b8",
      "filename": "Bedroom/download (1).jpg",
      "title": "Blonde Deepthroat Delight",
      "category": "Ecchi",
      "subcategory": "Bedroom",
      "tags": [
        "anime",
        "blonde",
        "oral",
        "nsfw",
        "explicit",
        "close-up"
      ],
      "colors": [
        "#201c20",
        "#c99f8b"
      ],
      "resolution": "3072x2048",
      "fileSize": "0.9 MB",
      "variants": {
        "original": {
          "url": "Bedroom/download (1).jpg",
          "resolution": "3072x2048",
          "size": "0.9 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "poolside-bukkake-bliss",
      "uuid": "82ddc581-7440-442f-99cb-77ac99ba85f2",
      "filename": "Pool/download (2).jpg",
      "title": "Poolside Bukkake Bliss",
      "category": "Ecchi",
      "subcategory": "Pool",
      "tags": [
        "anime",
        "blonde",
        "pool",
        "facial",
        "nsfw",
        "explicit",
        "sunglasses"
      ],
      "colors": [
        "#57c1cf",
        "#fab78b"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.6 MB",
      "variants": {
        "original": {
          "url": "Pool/download (2).jpg",
          "resolution": "1728x3072",
          "size": "0.6 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
        {
      "id": "silver-hair-sunlit-confession",
      "uuid": "60a09f14-73be-4213-acab-52f747b7f373",
      "filename": "Bedroom/ChatGPT Image Jun 2, 2026, 05_22_54 PM.png",
      "title": "Silver Hair Sunlit Confession",
      "category": "Ecchi",
      "subcategory": "Bedroom",
      "tags": [
        "anime",
        "white hair",
        "crop top",
        "nsfw",
        "ecchi",
        "blush"
      ],
      "colors": [
        "#4a3a32",
        "#878888"
      ],
      "resolution": "6688x3764",
      "fileSize": "3.7 MB",
      "variants": {
        "original": {
          "url": "Bedroom/ChatGPT Image Jun 2, 2026, 05_22_54 PM.png",
          "resolution": "6688x3764",
          "size": "3.7 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "bound-and-blushing",
      "uuid": "c5eaa017-8f68-4609-82fd-35038fe04ae1",
      "filename": "Bondage/fiona___fiona__ai_art__by_cosplaymakin_dmmp3b9-pre.jpg",
      "title": "Bound and Blushing",
      "category": "Ecchi",
      "subcategory": "Bondage",
      "tags": [
        "anime",
        "glasses",
        "bondage",
        "gag",
        "nsfw",
        "explicit",
        "collar"
      ],
      "colors": [
        "#f0cfba",
        "#d3b3a3"
      ],
      "resolution": "4380x2464",
      "fileSize": "1.0 MB",
      "variants": {
        "original": {
          "url": "Bondage/fiona___fiona__ai_art__by_cosplaymakin_dmmp3b9-pre.jpg",
          "resolution": "4380x2464",
          "size": "1.0 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "elsas-midnight-reveal",
      "uuid": "9c099d27-2250-4ddf-b2dd-34bd5a8437cb",
      "filename": "Frozen/elsa_strapslip_by_donnabellezza_dkmyigm-375w-2x_upscaled_4x.png",
      "title": "Elsa's Midnight Reveal",
      "category": "Ecchi",
      "subcategory": "Frozen",
      "tags": [
        "elsa",
        "frozen",
        "disney",
        "lingerie",
        "nsfw",
        "ecchi",
        "blonde"
      ],
      "colors": [
        "#9c6e61",
        "#1a2838"
      ],
      "resolution": "2784x2088",
      "fileSize": "6.1 MB",
      "variants": {
        "original": {
          "url": "Frozen/elsa_strapslip_by_donnabellezza_dkmyigm-375w-2x_upscaled_4x.png",
          "resolution": "2784x2088",
          "size": "6.1 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "shizukas-park-bench-tease",
      "uuid": "d99ea791-1425-4b0e-a14a-ef758a8530ad",
      "filename": "Original/shizuka_mikazuki_by_sialpi_dlwnen4-350t-2x_upscaled_4x.png",
      "title": "Shizuka's Park Bench Tease",
      "category": "Ecchi",
      "subcategory": "Original",
      "tags": [
        "anime",
        "sports bra",
        "park",
        "panties",
        "nsfw",
        "ecchi",
        "short hair"
      ],
      "colors": [
        "#7e787a",
        "#504156"
      ],
      "resolution": "1680x2800",
      "fileSize": "5.2 MB",
      "variants": {
        "original": {
          "url": "Original/shizuka_mikazuki_by_sialpi_dlwnen4-350t-2x_upscaled_4x.png",
          "resolution": "1680x2800",
          "size": "5.2 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "unbuttoned-and-bare",
      "uuid": "7434fd11-c94c-44d2-b7be-43564c1b5dba",
      "filename": "Bedroom/too_hot_by_therandomboii69_dkq04h5-375w-2x.jpg",
      "title": "Unbuttoned and Bare",
      "category": "Ecchi",
      "subcategory": "Bedroom",
      "tags": [
        "anime",
        "nude",
        "unbuttoned",
        "nsfw",
        "explicit",
        "close-up"
      ],
      "colors": [
        "#f5d8c9",
        "#e0c3b7"
      ],
      "resolution": "2048x3072",
      "fileSize": "0.8 MB",
      "variants": {
        "original": {
          "url": "Bedroom/too_hot_by_therandomboii69_dkq04h5-375w-2x.jpg",
          "resolution": "2048x3072",
          "size": "0.8 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    }
  ,
    {
      "id": "sexy-misty-in-bed",
      "uuid": "b3a8dc6c-80cc-447e-8311-f9c6ce077891",
      "filename": "Pokémon/sexy-misty-in-bed.jpg",
      "title": "Sexy Misty in Bed",
      "category": "Ecchi",
      "subcategory": "Pokémon",
      "tags": [
        "pokémon",
        "misty"
      ],
      "colors": [
        "#1B273A",
        "#E8CDC8"
      ],
      "resolution": "1332x2000",
      "fileSize": "0.3 MB",
      "variants": {
        "original": {
          "url": "Pokémon/sexy-misty-in-bed.jpg",
          "resolution": "1332x2000",
          "size": "0.3 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "mays-steamy-stargazing",
      "uuid": "5ca5d24c-cf27-4a1e-a732-362e5816426a",
      "filename": "Pokémon/mays-steamy-stargazing.png",
      "title": "May's Steamy Stargazing",
      "category": "Ecchi",
      "subcategory": "Pokémon",
      "tags": [
        "pokémon",
        "may",
        "nsfw",
        "ecchi"
      ],
      "colors": [
        "#D0B4AD",
        "#CB916F"
      ],
      "resolution": "1916x2800",
      "fileSize": "6.9 MB",
      "variants": {
        "original": {
          "url": "Pokémon/mays-steamy-stargazing.png",
          "resolution": "1916x2800",
          "size": "6.9 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "misty-s-water-type-selfie",
      "uuid": "84ced019-0cff-4213-8d51-ec00b04755e5",
      "filename": "Pokémon/misty-s-water-type-selfie.jpg",
      "title": "Misty’s Water-Type Selfie",
      "category": "Ecchi",
      "subcategory": "Pokémon",
      "tags": [
        "pokémon",
        "bikini",
        "ecchi",
        "misty"
      ],
      "colors": [
        "#D49F87",
        "#EDD6CC"
      ],
      "resolution": "3308x4840",
      "fileSize": "1.6 MB",
      "variants": {
        "original": {
          "url": "Pokémon/misty-s-water-type-selfie.jpg",
          "resolution": "3308x4840",
          "size": "1.6 MB"
        }
      },
      "uploadDate": "2026-08-23",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    }],
  "fantasy": [
    {
      "id": "crystalline-rift-valley",
      "uuid": "c05c0c70-95fe-5fdb-a3e7-1a08e08df027",
      "filename": "Crystalline Rift Valley.png",
      "title": "Crystalline Rift Valley",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "fantasy landscape",
        "crystal spire",
        "cosmic rift",
        "otherworldly",
        "stars",
        "neon",
        "sci-fi fantasy",
        "dark fantasy"
      ],
      "colors": [
        "#4f8fc0",
        "#20152f"
      ],
      "resolution": "6688x3764",
      "fileSize": "2.8 MB",
      "variants": {
        "original": {
          "url": "Crystalline Rift Valley.png",
          "resolution": "6688x3764",
          "size": "2.8 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "a-peaceful-night-by-the-lake",
      "uuid": "0a51642e-38c8-5a6d-b1e7-b9687854ccae",
      "filename": "A peaceful night by the lake.png",
      "title": "A Peaceful Night By The Lake",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "lake",
        "night",
        "fantasy",
        "the",
        "peaceful"
      ],
      "colors": [
        "#3b81a6",
        "#0d3150"
      ],
      "resolution": "4096x2304",
      "fileSize": "12.7 MB",
      "variants": {
        "original": {
          "url": "A peaceful night by the lake.png",
          "resolution": "4096x2304",
          "size": "12.7 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "anime-girl-with-white-hair-and-headphones",
      "uuid": "a5384dc1-649d-5f9a-a5f5-9e90c4dbb4de",
      "filename": "Anime girl with white hair and headphones.png",
      "title": "Anime Girl With White Hair And Headphones",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "girl",
        "anime",
        "white",
        "with",
        "hair",
        "headphones",
        "fantasy",
        "and"
      ],
      "colors": [
        "#4c4367",
        "#1d152d"
      ],
      "resolution": "4096x2304",
      "fileSize": "15.9 MB",
      "variants": {
        "original": {
          "url": "Anime girl with white hair and headphones.png",
          "resolution": "4096x2304",
          "size": "15.9 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "glow-of-the-lantern-province",
      "uuid": "3731a138-0df7-58e9-852a-cd456100d962",
      "filename": "Glow of the Lantern Province.png",
      "title": "Glow Of The Lantern Province",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "lantern",
        "fantasy",
        "the",
        "province",
        "glow"
      ],
      "colors": [
        "#7e4a3d",
        "#2e1619"
      ],
      "resolution": "4096x2304",
      "fileSize": "13.0 MB",
      "variants": {
        "original": {
          "url": "Glow of the Lantern Province.png",
          "resolution": "4096x2304",
          "size": "13.0 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "ocean-clouds-sunset-dreamy-landscape",
      "uuid": "062b15a2-57d4-54ec-af06-ead49824c7f9",
      "filename": "Ocean clouds sunset dreamy landscape.png",
      "title": "Ocean Clouds Sunset Dreamy Landscape",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "ocean",
        "dreamy",
        "sunset",
        "clouds",
        "fantasy",
        "landscape"
      ],
      "colors": [
        "#82587b",
        "#211e47"
      ],
      "resolution": "2304x4096",
      "fileSize": "17.0 MB",
      "variants": {
        "original": {
          "url": "Ocean clouds sunset dreamy landscape.png",
          "resolution": "2304x4096",
          "size": "17.0 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "pink-sakura-tree-anime-landscape",
      "uuid": "d1f674d0-8def-5833-a611-979ce8da65c4",
      "filename": "Pink sakura tree anime landscape.png",
      "title": "Pink Sakura Tree Anime Landscape",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "anime",
        "pink",
        "tree",
        "fantasy",
        "sakura",
        "landscape"
      ],
      "colors": [
        "#d17b5c",
        "#49282c"
      ],
      "resolution": "4096x2304",
      "fileSize": "17.5 MB",
      "variants": {
        "original": {
          "url": "Pink sakura tree anime landscape.png",
          "resolution": "4096x2304",
          "size": "17.5 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "silhouettes-in-serenity",
      "uuid": "59ea44c8-ce7d-5325-a4d5-6d8d38e4f3fa",
      "filename": "Silhouettes in Serenity.png",
      "title": "Silhouettes in Serenity",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "moonlight",
        "dark forest",
        "water",
        "dark blue",
        "cliffs",
        "serene",
        "atmospheric",
        "night",
        "fantasy",
        "mysterious"
      ],
      "colors": [
        "#335965",
        "#0b1519"
      ],
      "resolution": "4096x2296",
      "fileSize": "10.3 MB",
      "variants": {
        "original": {
          "url": "Silhouettes in Serenity.png",
          "resolution": "4096x2296",
          "size": "10.3 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-celestial-siege",
      "uuid": "0c1e225d-c4ba-5929-837a-40e7a55507a4",
      "filename": "The Celestial Siege.png",
      "title": "The Celestial Siege",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "dark moon",
        "forest",
        "warrior",
        "mysterious",
        "castle",
        "dark fantasy",
        "mist",
        "fantasy",
        "glowing staff",
        "epic"
      ],
      "colors": [
        "#98aaca",
        "#161e37"
      ],
      "resolution": "4096x2304",
      "fileSize": "9.6 MB",
      "variants": {
        "original": {
          "url": "The Celestial Siege.png",
          "resolution": "4096x2304",
          "size": "9.6 MB"
        }
      },
      "uploadDate": "2026-04-22",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-graveyard-of-fallen-heroes",
      "uuid": "8dd6cfea-b6f4-5b19-b311-a3802dfc6865",
      "filename": "The Graveyard of Fallen Heroes.png",
      "title": "The Graveyard of Fallen Heroes",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "graveyard",
        "forest",
        "fog",
        "mysterious",
        "red eye",
        "eerie",
        "dark fantasy",
        "dark castle",
        "fantasy",
        "glowing staff",
        "epic"
      ],
      "colors": [
        "#596f88",
        "#1c2533"
      ],
      "resolution": "4096x2304",
      "fileSize": "6.3 MB",
      "variants": {
        "original": {
          "url": "The Graveyard of Fallen Heroes.png",
          "resolution": "4096x2304",
          "size": "6.3 MB"
        }
      },
      "uploadDate": "2026-04-22",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "twilight-cityscape-with-cherry-blossoms",
      "uuid": "8467ab5e-fb62-5407-8664-d4de772f73fa",
      "filename": "Twilight cityscape with cherry blossoms.png",
      "title": "Twilight Cityscape With Cherry Blossoms",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "twilight",
        "with",
        "fantasy",
        "cityscape",
        "blossoms",
        "cherry"
      ],
      "colors": [
        "#a492db",
        "#404997"
      ],
      "resolution": "4096x2304",
      "fileSize": "15.4 MB",
      "variants": {
        "original": {
          "url": "Twilight cityscape with cherry blossoms.png",
          "resolution": "4096x2304",
          "size": "15.4 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "twilight-serenity-in-the-pine-forest",
      "uuid": "99443c13-f395-5581-ae45-04f506675f4f",
      "filename": "Twilight serenity in the pine forest.png",
      "title": "Twilight Serenity In The Pine Forest",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "forest",
        "twilight",
        "fantasy",
        "the",
        "pine",
        "serenity"
      ],
      "colors": [
        "#3981a8",
        "#051e36"
      ],
      "resolution": "4096x2304",
      "fileSize": "15.0 MB",
      "variants": {
        "original": {
          "url": "Twilight serenity in the pine forest.png",
          "resolution": "4096x2304",
          "size": "15.0 MB"
        }
      },
      "uploadDate": "2025-12-18",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "moonlight-over-the-blood-red-peaks",
      "uuid": "27ecb101-da99-50b8-9413-e08841fe13f3",
      "filename": "Moonlight Over the Blood-Red Peaks.png",
      "title": "Moonlight Over the Blood-Red Peaks",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "samurai",
        "ronin",
        "moonlight",
        "blood red",
        "mountains",
        "katana",
        "dark",
        "japanese",
        "fantasy",
        "cinematic"
      ],
      "colors": [
        "#57534d",
        "#3b3a37"
      ],
      "resolution": "4096x2304",
      "fileSize": "1.8 MB",
      "variants": {
        "original": {
          "url": "Moonlight Over the Blood-Red Peaks.png",
          "resolution": "4096x2304",
          "size": "1.8 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-blade-of-eternal-spring",
      "uuid": "012a14ae-74a1-53e7-8f7e-ce5fc33812f9",
      "filename": "The Blade of Eternal Spring.png",
      "title": "The Blade of Eternal Spring",
      "category": "Fantasy",
      "subcategory": null,
      "tags": [
        "sword",
        "cherry blossoms",
        "spring",
        "sakura",
        "blade",
        "fantasy",
        "glowing",
        "serene",
        "magical"
      ],
      "colors": [
        "#9f88a3",
        "#4f556e"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.4 MB",
      "variants": {
        "original": {
          "url": "The Blade of Eternal Spring.png",
          "resolution": "4096x2304",
          "size": "2.4 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    }
  ],
  "nature": [
    {
      "id": "crimson-blossoms-in-snow",
      "uuid": "66906936-e864-5751-af5a-f73a193eb8a8",
      "filename": "Crimson Blossoms in Snow.png",
      "title": "Crimson Blossoms in Snow",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "red blossoms",
        "snow",
        "winter",
        "branches",
        "misty lake",
        "serene",
        "nature",
        "floral"
      ],
      "colors": [
        "#bb342d",
        "#859093"
      ],
      "resolution": "6688x3764",
      "fileSize": "2.3 MB",
      "variants": {
        "original": {
          "url": "Crimson Blossoms in Snow.png",
          "resolution": "6688x3764",
          "size": "2.3 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "a-crescent-dream",
      "uuid": "9f711154-9186-5c8b-b3e2-ce0b0f59e6a9",
      "filename": "A Crescent Dream.png",
      "title": "A Crescent Dream",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "moonlight",
        "lake",
        "serene",
        "nature",
        "mountains",
        "cherry blossom",
        "crescent moon",
        "sakura",
        "night sky",
        "stars"
      ],
      "colors": [
        "#436583",
        "#0a2340"
      ],
      "resolution": "2300x4096",
      "fileSize": "10.3 MB",
      "variants": {
        "original": {
          "url": "A Crescent Dream.png",
          "resolution": "2300x4096",
          "size": "10.3 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "a-peaceful-rural-landscape-under-blue-skies",
      "uuid": "68607f1e-d7e1-5a11-9a2f-3f09c4d3891d",
      "filename": "A peaceful rural landscape under blue skies.png",
      "title": "A Peaceful Rural Landscape Under Blue Skies",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "under",
        "nature",
        "rural",
        "blue",
        "skies",
        "landscape",
        "peaceful"
      ],
      "colors": [
        "#a0c2b6",
        "#5b7762"
      ],
      "resolution": "4096x2304",
      "fileSize": "13.0 MB",
      "variants": {
        "original": {
          "url": "A peaceful rural landscape under blue skies.png",
          "resolution": "4096x2304",
          "size": "13.0 MB"
        }
      },
      "uploadDate": "2026-02-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "nocturne-in-monochrome",
      "uuid": "60e969d8-bc19-558b-ad8c-743d8e19530c",
      "filename": "Nocturne in Monochrome.png",
      "title": "Nocturne in Monochrome",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "black and white",
        "silhouette",
        "nature",
        "full moon",
        "monochrome",
        "bare trees",
        "night",
        "gothic",
        "spooky",
        "dark",
        "crows"
      ],
      "colors": [
        "#39393a",
        "#0a0b0b"
      ],
      "resolution": "4096x2304",
      "fileSize": "7.2 MB",
      "variants": {
        "original": {
          "url": "Nocturne in Monochrome.png",
          "resolution": "4096x2304",
          "size": "7.2 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "sunset-over-the-riverside-cityscapes",
      "uuid": "f329fc04-1c12-5223-8533-a8bdbfbe9296",
      "filename": "Sunset over the riverside cityscapes.png",
      "title": "Sunset Over The Riverside Cityscapes",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "cityscapes",
        "nature",
        "riverside",
        "sunset",
        "over",
        "the"
      ],
      "colors": [
        "#bf948e",
        "#724a4d"
      ],
      "resolution": "4096x2304",
      "fileSize": "14.0 MB",
      "variants": {
        "original": {
          "url": "Sunset over the riverside cityscapes.png",
          "resolution": "4096x2304",
          "size": "14.0 MB"
        }
      },
      "uploadDate": "2026-02-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-astral-orchard",
      "uuid": "9366f10f-a16c-532c-96db-6510127807e6",
      "filename": "The Astral Orchard.png",
      "title": "The Astral Orchard",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "petals",
        "ethereal",
        "astral",
        "nature",
        "cherry blossom",
        "blue",
        "dreamy",
        "flowers",
        "night sky",
        "galaxy",
        "stars"
      ],
      "colors": [
        "#46576e",
        "#09192f"
      ],
      "resolution": "2304x4096",
      "fileSize": "12.6 MB",
      "variants": {
        "original": {
          "url": "The Astral Orchard.png",
          "resolution": "2304x4096",
          "size": "12.6 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-gilded-sentinel",
      "uuid": "0a4351dc-44de-561d-8370-8dcfd7ec4d45",
      "filename": "The Gilded Sentinel.png",
      "title": "The Gilded Sentinel",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "lake",
        "landscape",
        "fog",
        "serene",
        "nature",
        "mountains",
        "mist",
        "golden tree",
        "fall",
        "autumn"
      ],
      "colors": [
        "#c4b896",
        "#494535"
      ],
      "resolution": "4096x2304",
      "fileSize": "15.4 MB",
      "variants": {
        "original": {
          "url": "The Gilded Sentinel.png",
          "resolution": "4096x2304",
          "size": "15.4 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-rivers-bedtime-story",
      "uuid": "8140a765-2a68-53fd-bf07-67f2df6a6922",
      "filename": "The River's Bedtime Story.png",
      "title": "The River's Bedtime Story",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "camping",
        "forest",
        "serene",
        "fireflies",
        "nature",
        "cherry blossom",
        "tent",
        "night",
        "cozy",
        "river",
        "stars"
      ],
      "colors": [
        "#3c4d5d",
        "#091427"
      ],
      "resolution": "2304x4096",
      "fileSize": "1.9 MB",
      "variants": {
        "original": {
          "url": "The River's Bedtime Story.png",
          "resolution": "2304x4096",
          "size": "1.9 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "whispers-of-the-spring-moon",
      "uuid": "1e5aa0eb-108d-524b-bc16-98bbcf39dc1c",
      "filename": "Whispers of the Spring Moon.png",
      "title": "Whispers of the Spring Moon",
      "category": "Nature",
      "subcategory": null,
      "tags": [
        "lake",
        "mount fuji",
        "serene",
        "nature",
        "full moon",
        "cherry blossom",
        "reflection",
        "japan",
        "night",
        "sakura",
        "spring"
      ],
      "colors": [
        "#677696",
        "#0f274a"
      ],
      "resolution": "2300x4096",
      "fileSize": "12.3 MB",
      "variants": {
        "original": {
          "url": "Whispers of the Spring Moon.png",
          "resolution": "2300x4096",
          "size": "12.3 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    }
  ],
  "pop culture n branding": [
    {
      "id": "gamers-soul-radiant-controller-glow",
      "uuid": "6fdd04ff-88e8-5279-8e03-7d2ed5ce9b64",
      "filename": "Gamers Soul Radiant Controller Glow.png",
      "title": "Gamer's Soul: Radiant Controller Glow",
      "category": "Pop Culture n Branding",
      "subcategory": null,
      "tags": [
        "gamer",
        "playstation",
        "ps5",
        "pop culture",
        "radiant",
        "gaming",
        "controller",
        "glow"
      ],
      "colors": [
        "#98eafd",
        "#87afd6"
      ],
      "resolution": "2304x4096",
      "fileSize": "5.6 MB",
      "variants": {
        "original": {
          "url": "Gamers Soul Radiant Controller Glow.png",
          "resolution": "2304x4096",
          "size": "5.6 MB"
        }
      },
      "uploadDate": "2026-02-21",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "spotify-street-beats",
      "uuid": "d63bd376-6ca8-538c-91b4-7a80020871b3",
      "filename": "Spotify Street Beats.png",
      "title": "Spotify Street Beats",
      "category": "Pop Culture n Branding",
      "subcategory": null,
      "tags": [
        "spotify",
        "street",
        "pop culture n branding",
        "beats"
      ],
      "colors": [
        "#f5eec8",
        "#535d40"
      ],
      "resolution": "2304x4096",
      "fileSize": "8.8 MB",
      "variants": {
        "original": {
          "url": "Spotify Street Beats.png",
          "resolution": "2304x4096",
          "size": "8.8 MB"
        }
      },
      "uploadDate": "2025-12-20",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-starlet-prowl",
      "uuid": "e417bda8-9a1e-5c2f-a0e1-03d5552c0d05",
      "filename": "The Starlet Prowl.png",
      "title": "The Starlet Prowl",
      "category": "Pop Culture n Branding",
      "subcategory": null,
      "tags": [
        "black cat",
        "cartoon",
        "retro",
        "sylvester",
        "looney tunes",
        "pop culture",
        "illustration",
        "cat",
        "cute",
        "minimalist",
        "classic"
      ],
      "colors": [
        "#f7f4ee",
        "#928d8a"
      ],
      "resolution": "2304x4096",
      "fileSize": "3.6 MB",
      "variants": {
        "original": {
          "url": "The Starlet Prowl.png",
          "resolution": "2304x4096",
          "size": "3.6 MB"
        }
      },
      "uploadDate": "2026-04-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    }
  ],
  "gaming": [
    {
      "id": "minecraft-battle-for-the-end",
      "uuid": "6d0055f3-cc81-503d-a118-96e081f981c9",
      "filename": "Minecraft/Minecraft Battle for the End.png",
      "title": "Minecraft: Battle for the End",
      "category": "Gaming",
      "subcategory": "Minecraft",
      "tags": [
        "minecraft",
        "ender dragon",
        "the end",
        "battle",
        "steve",
        "diamond armor",
        "gaming",
        "Minecraft"
      ],
      "colors": [
        "#231643",
        "#281341"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.2 MB",
      "variants": {
        "original": {
          "url": "Minecraft/Minecraft Battle for the End.png",
          "resolution": "2304x4096",
          "size": "2.2 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "minecraft-beyond-the-caves-mouth",
      "uuid": "fa779bd2-1598-5ef5-89e2-aacf912d1fb9",
      "filename": "Minecraft/Minecraft Beyond the Cave's Mouth.png",
      "title": "Minecraft: Beyond the Cave's Mouth",
      "category": "Gaming",
      "subcategory": "Minecraft",
      "tags": [
        "minecraft",
        "cave",
        "exploration",
        "adventure",
        "underground",
        "gaming",
        "Minecraft"
      ],
      "colors": [
        "#4c5a57",
        "#454134"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.5 MB",
      "variants": {
        "original": {
          "url": "Minecraft/Minecraft Beyond the Cave's Mouth.png",
          "resolution": "2304x4096",
          "size": "2.5 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "minecraft-the-dragons-requiem",
      "uuid": "fd2e97f3-13ae-5a08-b8f8-32bdc037ff1b",
      "filename": "Minecraft/Minecraft The Dragon's Requiem.png",
      "title": "Minecraft: The Dragon's Requiem",
      "category": "Gaming",
      "subcategory": "Minecraft",
      "tags": [
        "minecraft",
        "ender dragon",
        "requiem",
        "dragon",
        "end",
        "purple",
        "dark",
        "gaming",
        "Minecraft"
      ],
      "colors": [
        "#372a3f",
        "#201321"
      ],
      "resolution": "2304x4096",
      "fileSize": "2.0 MB",
      "variants": {
        "original": {
          "url": "Minecraft/Minecraft The Dragon's Requiem.png",
          "resolution": "2304x4096",
          "size": "2.0 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    },
    {
      "id": "the-cozy-meadows-of-minecraft",
      "uuid": "2e4f1b7d-fe1a-5f6e-9c8f-4eeef11d071c",
      "filename": "Minecraft/The Cozy Meadows of Minecraft.png",
      "title": "The Cozy Meadows of Minecraft",
      "category": "Gaming",
      "subcategory": "Minecraft",
      "tags": [
        "minecraft",
        "meadows",
        "cozy",
        "green",
        "nature",
        "peaceful",
        "sunshine",
        "gaming",
        "Minecraft"
      ],
      "colors": [
        "#a46e63",
        "#7b753d"
      ],
      "resolution": "4096x2304",
      "fileSize": "2.2 MB",
      "variants": {
        "original": {
          "url": "Minecraft/The Cozy Meadows of Minecraft.png",
          "resolution": "4096x2304",
          "size": "2.2 MB"
        }
      },
      "uploadDate": "2026-05-09",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0
    }
  ,
    {
      "id": "lumines-golden-hour-rest",
      "uuid": "f6958dcc-647b-4110-90ed-35860c748456",
      "filename": "Genshin Impact/lumines-golden-hour-rest.png",
      "title": "Lumine's Golden Hour Rest",
      "category": "Gaming",
      "subcategory": "Genshin Impact",
      "tags": [
        "game",
        "genshin impact",
        "lumine",
        "boobs"
      ],
      "colors": [
        "#888888",
        "#444444"
      ],
      "resolution": "5000x2800",
      "fileSize": "14.2 MB",
      "variants": {
        "original": {
          "url": "Genshin Impact/lumines-golden-hour-rest.png",
          "resolution": "5000x2800",
          "size": "14.2 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "yunas-velvet-temptation",
      "uuid": "1d50e1cc-2ea4-4458-8083-6cafc4c3ff69",
      "filename": "Magic: The Gathering/yunas-velvet-temptation.png",
      "title": "Yuna's Velvet Temptation",
      "category": "Gaming",
      "subcategory": "Magic: The Gathering",
      "tags": [
        "yuna",
        "grand summoner",
        "game",
        "magic: the gathering"
      ],
      "colors": [
        "#D9C5BC",
        "#C89A84"
      ],
      "resolution": "1584x2800",
      "fileSize": "5.7 MB",
      "variants": {
        "original": {
          "url": "Magic: The Gathering/yunas-velvet-temptation.png",
          "resolution": "1584x2800",
          "size": "5.7 MB"
        }
      },
      "uploadDate": "2026-08-31",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    }],
  "real": [
    {
      "id": "cyber-chic-rebellion",
      "uuid": "a37b4e4f-fde5-4542-8fb2-cd18a70f13e0",
      "filename": "Cyber-Chic Rebellion.jpg",
      "title": "Cyber-Chic Rebellion",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "motorcycle",
        "biker",
        "nsfw",
        "neon",
        "night",
        "leather",
        "erotic"
      ],
      "colors": [
        "#1a1a1a",
        "#c0392b"
      ],
      "resolution": "3072x1728",
      "fileSize": "0.6 MB",
      "variants": {
        "original": {
          "url": "Cyber-Chic Rebellion.jpg",
          "resolution": "3072x1728",
          "size": "0.6 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "exhibition-in-neon",
      "uuid": "1155e31f-3ad8-4056-a0d2-e3e8cb69a357",
      "filename": "Exhibition in Neon.jpg",
      "title": "Exhibition in Neon",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "racing",
        "neon",
        "nsfw",
        "topless",
        "motorsport",
        "erotic"
      ],
      "colors": [
        "#e74c3c",
        "#1a1a1a"
      ],
      "resolution": "3072x1728",
      "fileSize": "0.7 MB",
      "variants": {
        "original": {
          "url": "Exhibition in Neon.jpg",
          "resolution": "3072x1728",
          "size": "0.7 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "adrenaline-catalyst",
      "uuid": "903b6574-6376-47dc-be54-038732482846",
      "filename": "Adrenaline Catalyst.jpg",
      "title": "Adrenaline Catalyst",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "motorcycle",
        "bikini",
        "nsfw",
        "wet",
        "racing",
        "helmet",
        "erotic"
      ],
      "colors": [
        "#2c3e50",
        "#e74c3c"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.7 MB",
      "variants": {
        "original": {
          "url": "Adrenaline Catalyst.jpg",
          "resolution": "1728x3072",
          "size": "0.7 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "the-intersection-of-intimacy",
      "uuid": "c48d7ef2-7008-456e-90fd-3e73b26ad071",
      "filename": "The Intersection of Intimacy.jpg",
      "title": "The Intersection of Intimacy",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "motorsport",
        "topless",
        "nsfw",
        "racing",
        "intimate",
        "erotic"
      ],
      "colors": [
        "#1a1a1a",
        "#f39c12"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.7 MB",
      "variants": {
        "original": {
          "url": "The Intersection of Intimacy.jpg",
          "resolution": "1728x3072",
          "size": "0.7 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "blowjob-time",
      "uuid": "8e0ec29d-2fb0-44df-857c-8c99bf1f6bde",
      "filename": "blowjob time.jpg",
      "title": "Blowjob Time",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "nsfw",
        "explicit",
        "gym",
        "oral",
        "erotic"
      ],
      "colors": [
        "#2c3e50",
        "#e8d5b7"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.8 MB",
      "variants": {
        "original": {
          "url": "blowjob time.jpg",
          "resolution": "1728x3072",
          "size": "0.8 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "zero-hour-on-neon-street",
      "uuid": "4fbe8d45-a645-42ef-b496-8b8ff0e26d0a",
      "filename": "Zero Hour on Neon Street.jpg",
      "title": "Zero Hour on Neon Street",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "motorcycle",
        "neon",
        "nsfw",
        "street",
        "night",
        "couple",
        "erotic"
      ],
      "colors": [
        "#1a1a1a",
        "#9b59b6"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.9 MB",
      "variants": {
        "original": {
          "url": "Zero Hour on Neon Street.jpg",
          "resolution": "1728x3072",
          "size": "0.9 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "public-pulse",
      "uuid": "a21662c7-ca6b-478d-a1a2-cc305241a64b",
      "filename": "Public Pulse.jpg",
      "title": "Public Pulse",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "motorcycle",
        "nsfw",
        "couple",
        "public",
        "erotic",
        "street"
      ],
      "colors": [
        "#2c3e50",
        "#e74c3c"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.9 MB",
      "variants": {
        "original": {
          "url": "Public Pulse.jpg",
          "resolution": "1728x3072",
          "size": "0.9 MB"
        }
      },
      "uploadDate": "2026-05-11",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "mirror-selfie-confidence",
      "uuid": "59684a42-18ad-428a-a864-043874cdeb09",
      "filename": "d4c4165f323f5a97b8803294614272b0ab55c11660c03a9be03705d8c492ad90.jpeg",
      "title": "Mirror Selfie Confidence",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "selfie",
        "nude",
        "nsfw",
        "explicit",
        "bedroom"
      ],
      "colors": [
        "#4d3a2e",
        "#2b211c"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.4 MB",
      "variants": {
        "original": {
          "url": "d4c4165f323f5a97b8803294614272b0ab55c11660c03a9be03705d8c492ad90.jpeg",
          "resolution": "1728x3072",
          "size": "0.4 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    },
    {
      "id": "poolside-red-bikini-drip",
      "uuid": "cf791dc7-fd40-4d58-b46c-04902a11b70a",
      "filename": "download 2.jpg",
      "title": "Poolside Red Bikini Drip",
      "category": "Real",
      "subcategory": null,
      "tags": [
        "real",
        "bikini",
        "pool",
        "nsfw",
        "wet",
        "sunglasses"
      ],
      "colors": [
        "#77a9a2",
        "#784a2f"
      ],
      "resolution": "1728x3072",
      "fileSize": "0.5 MB",
      "variants": {
        "original": {
          "url": "download 2.jpg",
          "resolution": "1728x3072",
          "size": "0.5 MB"
        }
      },
      "uploadDate": "2026-08-14",
      "downloads": 0,
      "likes": 0,
      "rating": 0,
      "voteCount": 0,
      "nsfw": true
    }
  ]
};

const IS_NSFW_SITE = import.meta.env.VITE_NSFW === 'true';

// Flatten all wallpapers into a single array
// Main site hides nsfw:true entries; NSFW site shows ONLY nsfw:true entries
const getAllWallpapers = () => {
  const all = Object.values(wallpaperData).flat();
  if (IS_NSFW_SITE) return all.filter(w => w.nsfw);
  return all.filter(w => !w.nsfw);
};

// Get wallpapers by category
const getWallpapersByCategory = (category) => {
  const wallpapers = wallpaperData[category.toLowerCase()] || [];
  if (IS_NSFW_SITE) return wallpapers.filter(w => w.nsfw);
  return wallpapers.filter(w => !w.nsfw);
};

// Search wallpapers
const searchWallpapers = (query) => {
  const allWallpapers = getAllWallpapers();
  const lowerQuery = query.toLowerCase();
  
  return allWallpapers.filter(wallpaper => {
    return (
      wallpaper.title.toLowerCase().includes(lowerQuery) ||
      wallpaper.category.toLowerCase().includes(lowerQuery) ||
      wallpaper.tags.some(tag => tag.toLowerCase().includes(lowerQuery))
    );
  });
};

// Get wallpaper by ID
const getWallpaperById = (id) => {
  const allWallpapers = getAllWallpapers();
  return allWallpapers.find(wallpaper => wallpaper.id === id);
};

// Get categories — only categories that have visible wallpapers for this site mode
const getCategories = () => {
  return Object.keys(wallpaperData)
    .map(key => {
      const visible = IS_NSFW_SITE
        ? wallpaperData[key].filter(w => w.nsfw)
        : wallpaperData[key].filter(w => !w.nsfw);
      return { name: key.charAt(0).toUpperCase() + key.slice(1), slug: key, count: visible.length };
    })
    .filter(cat => cat.count > 0);
};

// Get subcategories for a specific category
const getSubcategories = (category) => {
  const wallpapers = getWallpapersByCategory(category);
  const subcategories = new Map();

  wallpapers.forEach(w => {
    if (w.subcategory) {
      const key = w.subcategory;
      if (!subcategories.has(key)) {
        subcategories.set(key, {
          name: w.subcategory.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
          slug: w.subcategory,
          count: 0
        });
      }
      subcategories.get(key).count++;
    }
  });

  return Array.from(subcategories.values()).sort((a, b) => a.name.localeCompare(b.name));
};

// Get all subcategories across all categories
const getAllSubcategories = () => {
  const allWallpapers = getAllWallpapers();
  const subcategories = new Map();

  allWallpapers.forEach(w => {
    if (w.subcategory) {
      const key = `${w.category.toLowerCase()}-${w.subcategory}`;
      if (!subcategories.has(key)) {
        subcategories.set(key, {
          category: w.category,
          name: w.subcategory.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
          slug: w.subcategory,
          count: 0
        });
      }
      subcategories.get(key).count++;
    }
  });

  return Array.from(subcategories.values());
};

// Get wallpapers by category and subcategory
const getWallpapersBySubcategory = (category, subcategory) => {
  const wallpapers = getWallpapersByCategory(category);
  return wallpapers.filter(w => w.subcategory === subcategory);
};

// Track download
const trackDownload = async (id) => {
  const wallpaper = getWallpaperById(id);
  if (!wallpaper) return 0;

  // Check if user is authenticated (including anonymous)
  const user = authManager.getCurrentUser();

  if (user && supabase) {
    try {
      await supabase
        .from('user_downloads')
        .insert({
          user_id: user.id,
          wallpaper_id: wallpaper.id
        });

      wallpaper.downloads++;
      return wallpaper.downloads;
    } catch (error) {
      console.error('Error tracking download:', error);
    }
  }

  // If Supabase fails or user unavailable, still increment locally for current session
  wallpaper.downloads++;
  return wallpaper.downloads;
};

// Toggle like for a wallpaper
const toggleLike = async (id) => {
  const wallpaper = getWallpaperById(id);
  if (!wallpaper) return false;

  const user = authManager.getCurrentUser();

  if (user && supabase) {
    try {
      const { data: existingLike } = await supabase
        .from('user_likes')
        .select('*')
        .eq('user_id', user.id)
        .eq('wallpaper_id', wallpaper.id)
        .single();

      if (existingLike) {
        await supabase
          .from('user_likes')
          .delete()
          .eq('user_id', user.id)
          .eq('wallpaper_id', wallpaper.id);

        wallpaper.likes = Math.max(0, wallpaper.likes - 1);
        return false;
      } else {
        await supabase
          .from('user_likes')
          .insert({
            user_id: user.id,
            wallpaper_id: wallpaper.id
          });

        wallpaper.likes++;
        return true;
      }
    } catch (error) {
      console.error('Error toggling like:', error);
    }
  }

  return false;
};

// Check if wallpaper is liked
const isLiked = async (id) => {
  const user = authManager.getCurrentUser();
  const wallpaper = getWallpaperById(id);

  if (user && supabase && wallpaper) {
    try {
      const { data, error } = await supabase
        .from('user_likes')
        .select('*')
        .eq('user_id', user.id)
        .eq('wallpaper_id', wallpaper.id)
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('Error checking like:', error);
      }

      return !!data;
    } catch (error) {
      console.error('Error checking like:', error);
    }
  }

  return false;
};

// Rate a wallpaper
const rateWallpaper = async (id, rating) => {
  const wallpaper = getWallpaperById(id);
  if (!wallpaper || rating < 1 || rating > 5) return null;

  const user = authManager.getCurrentUser();

  if (user && supabase) {
    try {
      const { data: existingRating } = await supabase
        .from('user_ratings')
        .select('*')
        .eq('user_id', user.id)
        .eq('wallpaper_id', wallpaper.id)
        .single();

      if (existingRating) {
        await supabase
          .from('user_ratings')
          .update({ rating, updated_at: new Date().toISOString() })
          .eq('user_id', user.id)
          .eq('wallpaper_id', wallpaper.id);

        const oldTotal = wallpaper.rating * wallpaper.voteCount;
        const newTotal = oldTotal - existingRating.rating + rating;
        wallpaper.rating = newTotal / wallpaper.voteCount;
      } else {
        await supabase
          .from('user_ratings')
          .insert({
            user_id: user.id,
            wallpaper_id: wallpaper.id,
            rating
          });

        const oldTotal = wallpaper.rating * wallpaper.voteCount;
        wallpaper.voteCount++;
        wallpaper.rating = (oldTotal + rating) / wallpaper.voteCount;
      }

      return {
        rating: wallpaper.rating,
        voteCount: wallpaper.voteCount
      };
    } catch (error) {
      console.error('Error rating wallpaper:', error);
    }
  }

  return null;
};

// Get user's rating for a wallpaper
const getUserRating = async (id) => {
  const user = authManager.getCurrentUser();
  const wallpaper = getWallpaperById(id);

  if (user && supabase && wallpaper) {
    try {
      const { data } = await supabase
        .from('user_ratings')
        .select('rating')
        .eq('user_id', user.id)
        .eq('wallpaper_id', wallpaper.id)
        .single();

      return data?.rating || 0;
    } catch (error) {
      console.error('Error getting user rating:', error);
    }
  }

  return 0;
};

// Get real-time stats for a wallpaper
const getWallpaperStats = async (id) => {
  if (!supabase) return null;

  try {
    const [downloads, likes, ratings] = await Promise.all([
      supabase.from('user_downloads').select('*', { count: 'exact', head: true }).eq('wallpaper_id', id),
      supabase.from('user_likes').select('*', { count: 'exact', head: true }).eq('wallpaper_id', id),
      supabase.from('user_ratings').select('rating').eq('wallpaper_id', id)
    ]);

    const ratingData = ratings.data || [];
    const voteCount = ratingData.length;
    const avgRating = voteCount > 0 
      ? ratingData.reduce((acc, curr) => acc + curr.rating, 0) / voteCount 
      : 0;

    return {
      downloads: downloads.count || 0,
      likes: likes.count || 0,
      rating: avgRating,
      voteCount: voteCount
    };
  } catch (error) {
    console.error('Error fetching wallpaper stats:', error);
    return null;
  }
};

// Sync global statistics from Supabase
const syncGlobalStats = async () => {
  if (!supabase) return;

  try {
    console.log('Syncing global stats from Supabase...');
    // In a future update, we can implement bulk sync here
  } catch (error) {
    console.error('Failed to sync global stats:', error);
  }
};

// Get related wallpapers based on tags
const getRelatedWallpapers = (wallpaperId, limit = 6) => {
  const wallpaper = getWallpaperById(wallpaperId);
  if (!wallpaper) return [];

  const allWallpapers = getAllWallpapers();

  // Calculate tag overlap for each wallpaper
  const scored = allWallpapers
    .filter(w => w.id !== wallpaperId)
    .map(w => {
      const commonTags = w.tags.filter(tag => wallpaper.tags.includes(tag));
      return {
        wallpaper: w,
        score: commonTags.length
      };
    })
    .filter(item => item.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map(item => item.wallpaper);

  return scored;
};

// Get wallpapers by tag
const getWallpapersByTag = (tag) => {
  const allWallpapers = getAllWallpapers();
  return allWallpapers.filter(w => w.tags.includes(tag.toLowerCase()));
};

// Get popular tags
const getPopularTags = (limit = 10) => {
  const allWallpapers = getAllWallpapers();
  const tagCounts = {};

  allWallpapers.forEach(w => {
    w.tags.forEach(tag => {
      tagCounts[tag] = (tagCounts[tag] || 0) + 1;
    });
  });

  return Object.entries(tagCounts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, limit)
    .map(([tag, count]) => ({ tag, count }));
};

// Export module
export {
  wallpaperData,
  getAllWallpapers,
  getWallpapersByCategory,
  getWallpapersBySubcategory,
  searchWallpapers,
  getWallpaperById,
  getCategories,
  getSubcategories,
  getAllSubcategories,
  trackDownload,
  toggleLike,
  isLiked,
  rateWallpaper,
  getUserRating,
  getWallpaperStats,
  syncGlobalStats,
  getRelatedWallpapers,
  getWallpapersByTag,
  getPopularTags
};

